/* === Fix 5: Accessible mute toggle === */


  document.querySelectorAll('[data-sound-toggle]').forEach((btn) => {
    const slide = btn.closest('[class*="slider-content-"]') || btn.parentElement;
    const video = slide.querySelector('video');
    if (!video) return;

    const sync = () => {
      btn.setAttribute('aria-pressed', String(video.muted));
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    };

    btn.addEventListener('click', () => { video.muted = !video.muted; sync(); });
    video.addEventListener('volumechange', sync);
    sync();
});





/*! Angelus Direct - meaningful alt text generated from Shopify metadata. Requires jQuery 3.x. */
  ;(function ($) {
    'use strict';
    if (!$) { return; }

    var CFG = {
      fallbackBrand: 'Angelus',
      iconMaxPx: 60,
      skipWithin: '[class*="kl-private"],[class*="klaviyo"],[id*="gorgias"],[class*="gorgias"],iframe',
      thirdPartyAlt: { 'user picture': 'Customer review photo' },
      decorativeAlts: ['flexible','durable','mixable','made in usa','swatch icon','us','icon','star','arrow','image','badge'],
      overrideFiles: [
        { match: 'How_to_Use_Angelus_Paint_Infographic',
          alt: 'Infographic: four-step guide to using Angelus paint - prepare the surface, paint it, apply a finisher, then allow 24 hours to dry and cure' }
      ],
      fallbackFiles: [
        { match: 'works_on_shoes',        alt: 'Angelus paint used on leather shoes, bags and furniture' },
        { match: 'works_on_Canvas',       alt: 'Angelus paint used on canvas jackets, shoes and bags' },
        { match: 'works_on_woods',        alt: 'Angelus paint used on a wooden surface' },
        { match: 'works_on_plastics',     alt: 'Angelus paint used on plastic surfaces' },
        { match: 'works_on_Denim',        alt: 'Angelus paint used on denim' },
        { match: 'works_on_waterbottles', alt: 'Angelus paint used on a metal water bottle' },
        { match: '2-soft',                alt: 'Angelus 2-Soft fabric medium, mixed with paint to keep fabric soft' },
        { match: '2-Hard',                alt: 'Angelus 2-Hard additive, used for painting hard surfaces such as plastic' },
        { match: '4-Coat_Finishers',      alt: 'Angelus 4-Coat finisher bottles used to seal finished paintwork' },
        { match: 'Holding_Airbrush',      alt: 'Hand holding an airbrush loaded with Angelus paint' }
      ]
    };

    var TYPES = [
      [/cleaning kit/i,            { noun: 'shoe cleaning kit', cat: 'cleaner' }],
      [/dye kit/i,                 { noun: 'dye kit', cat: 'dye' }],
      [/paint kit|kit$|bundle/i,   { noun: 'paint kit', cat: 'paint' }],
      [/glitterlite/i,             { noun: 'glitter acrylic leather paint', cat: 'paint' }],
      [/neon paint/i,              { noun: 'neon acrylic leather paint', cat: 'paint' }],
      [/pearlescent paint/i,       { noun: 'pearlescent acrylic leather paint', cat: 'paint' }],
      [/metallic paint/i,          { noun: 'metallic acrylic leather paint', cat: 'paint' }],
      [/instant midsole/i,         { noun: 'midsole paint pen', cat: 'paint' }],
      [/paint additive/i,          { noun: 'paint additive', cat: 'paint' }],
      [/paint/i,                   { noun: 'acrylic leather paint', cat: 'paint' }],
      [/low voc leather dye/i,     { noun: 'low-VOC leather dye', cat: 'dye' }],
      [/suede dye/i,               { noun: 'suede dye', cat: 'dye' }],
      [/leather dye/i,             { noun: 'leather dye', cat: 'dye' }],
      [/dye/i,                     { noun: 'fabric dye', cat: 'dye' }],
      [/top coat|bottom coat|finisher/i, { noun: 'acrylic finisher', cat: 'finisher' }],
      [/cleaner|whitener/i,        { noun: 'shoe cleaner', cat: 'cleaner' }],
      [/conditioner/i,             { noun: 'leather conditioner', cat: 'conditioner' }],
      [/lustre cream|shoe polish|instant shine/i, { noun: 'shoe polish', cat: 'polish' }],
      [/aglet/i,                   { noun: 'shoelace aglets', cat: 'laces' }],
      [/lace lock/i,               { noun: 'lace locks', cat: 'laces' }],
      [/shoelace|laces|oval/i,     { noun: 'shoelaces', cat: 'laces' }],
      [/apparel|^angelus$/i,       { noun: 'apparel', cat: 'apparel' }],
      [/sticker/i,                 { noun: 'sticker', cat: 'product' }],
      [/gift card/i,               { noun: 'gift card', cat: 'product' }],
      [/accessor/i,                { noun: 'accessory', cat: 'product' }]
    ];

    var ROLES = [
      { re: /infographic|how ?to/i,       b: function (c) { return 'Infographic explaining how to use ' + c.applyNoun; } },
      { re: /flat ?lay/i,                 b: function (c) { return 'Flat lay showing the items included in ' + c.title; } },
      { re: /swatch/i,                    b: function (c) { return (c.colour || c.title) + ' colour swatch'; } },
      { re: /canvas/i,                    b: function (c) { return c.applyNoun + ' being applied to canvas'; } },
      { re: /wood/i,                      b: function (c) { return c.applyNoun + ' being applied to wood'; } },
      { re: /denim/i,                     b: function (c) { return c.applyNoun + ' being applied to denim'; } },
      { re: /plastic/i,                   b: function (c) { return c.applyNoun + ' being applied to plastic'; } },
      { re: /water ?bottle/i,             b: function (c) { return c.applyNoun + ' being applied to a metal water bottle'; } },
      { re: /sneaker|shoes?\b|on ?feet/i, b: function (c) { return c.applyNoun + ' being applied to a sneaker'; } },
      { re: /airbrush/i,                  b: function (c) { return c.applyNoun + ' being applied with an airbrush'; } },
      { re: /brush/i,                     b: function (c) { return c.applyNoun + ' being applied with a paint brush'; } },
      { re: /leather/i,                   b: function (c) { return c.applyNoun + ' being applied to leather'; } },
      { re: /litho|label|back|rear/i,     b: function (c) { return c.title + ' product label'; } },
      { re: /lifestyle|worn/i,            b: function (c) { return c.title + ' shown in use'; } }
    ];

    var NOISE_SIZES = /^(default title|1 (kit|bundle|pack|set|each|piece)s?)$/i;

    function clean(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
    function titleCase(s) { return s.replace(/\b[a-z]/g, function (m) { return m.toUpperCase(); }); }
    function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    function fileOf(img) {
      var s = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') ||
              img.getAttribute('data-original') || img.getAttribute('data-lazy') || '';
      /* some apps dump the image URL into alt - use it as a last resort source of the filename */
      if (!s) { var a = img.getAttribute('alt') || ''; if (/^https?:|\//.test(a)) { s = a; } }
      return s.split('?')[0].split('/').pop();
    }
    function baseName(f) {
      return f.replace(/\.(jpe?g|png|webp|gif|avif)$/i, '')
              .replace(/_\d+x\d*$/, '')
              .replace(/_?[0-9a-f]{8}-[0-9a-f-]{10,}$/i, '')
              .replace(/-\d{5,}$/, '');
    }

    /* Angelus colour-code convention: 001-Black-1-oz-2_500x.jpg, 451-Riot-Red-Swatch.jpg, 005-White.jpg */
    function parseColourFile(f) {
      var b = baseName(f).replace(/[\s_-]+/g, '-').replace(/([A-Za-z])(\d)/g, '$1-$2').replace(/^-|-$/g, '');
      var m = b.match(/^(\d{3})-([A-Za-z][A-Za-z-]*?)(?:-(\d+(?:\.\d+)?)-?oz)?(?:-\d+)*$/i);
      if (!m) { return null; }
      var n = m[2].replace(/-+/g, ' ').replace(/\s*swatch\s*$/i, '').trim();
      if (!n) { return null; }
      return { colour: titleCase(n.toLowerCase()), size: m[3] ? m[3] + ' oz.' : null, isSwatch: /swatch/i.test(b) };
    }

    /* Strip the product's own words out of the filename so 'shoe-polish.jpg' is not read as a lifestyle shot */
    function roleBase(file, p) {
      var b = baseName(file).replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase().replace(/[-_]+/g, ' ');
      var toks = [];
      if (p && p.handle) { toks = toks.concat(String(p.handle).split('-')); }
      if (p && p.title)  { toks = toks.concat(clean(p.title).toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(' ')); }
      if (p && p.type)   { toks = toks.concat(clean(p.type).toLowerCase().split(' ')); }
      toks.forEach(function (t) {
        if (!t || t.length < 3) { return; }
        b = b.replace(new RegExp('(^|\\s)' + esc(t) + '(?=\\s|$)', 'g'), ' ');
      });
      return b.replace(/\b\d+\b/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function brandOf(p) {
      var v = clean(p && p.vendor) || CFG.fallbackBrand;
      return v.replace(/\s*Direct\s*$/i, '').trim() || CFG.fallbackBrand;
    }
    function prefix(brand, noun) { return new RegExp('^' + esc(brand), 'i').test(noun) ? noun : brand + ' ' + noun; }
    function joinList(a) {
      if (!a || !a.length) { return ''; }
      if (a.length === 1) { return a[0]; }
      var s = (a.length === 2) ? a[0] + ' and ' + a[1]
                              : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
      if (s.length > 40) { s = a[0] + ' to ' + a[a.length - 1]; }
      return s.length > 40 ? '' : s;
    }

    function typeInfo(p) {
      var t = clean(p && p.type);
      if (/(shoe)?laces$/i.test(t) && t.length > 6) { return { noun: t.toLowerCase().replace(/"/g, ''), cat: 'laces' }; }
      var probe = t || clean(p && p.title);
      for (var i = 0; i < TYPES.length; i++) { if (TYPES[i][0].test(probe)) { return TYPES[i][1]; } }
      return { noun: t.toLowerCase() || 'product', cat: 'product' };
    }

    function ctxFor(p) {
      var info = typeInfo(p), brand = brandOf(p), sizes = null, i;
      if (p.options) {
        for (i = 0; i < p.options.length; i++) {
          if (/size|length|volume/i.test(p.options[i].name)) { sizes = p.options[i].values; break; }
        }
      }
      var strip = clean(p.type).split(' ').concat(String(info.noun).split(' '))
        .concat([brand, 'Angelus', 'Direct', 'Lace', 'Lab', 'Paint', 'Dye', 'Kit', 'Laces', 'Shoelaces', 'Shoe', 'Color', 'Colour', 'Assortment', 'Replacement']);
      var col = clean(p.title);
      strip.forEach(function (w) { if (w && w.length >= 3) { col = col.replace(new RegExp('\\b' + esc(w) + '\\b', 'ig'), ' '); } });
      col = clean(col.replace(/[-|]+/g, ' '));
      var sizeStr = (sizes && sizes.length) ? joinList(sizes) : null;
      if (sizeStr && NOISE_SIZES.test(sizeStr)) { sizeStr = null; }
      return {
        title: clean(p.title), brand: brand, noun: info.noun, cat: info.cat, colour: col,
        brandNoun: (new RegExp('\\b' + esc(brand) + '\\b', 'i').test(clean(p.title)) ? info.noun : prefix(brand, info.noun)),
        applyNoun: prefix(brand, (info.cat === 'product' || info.cat === 'apparel') ? info.noun : info.cat),
        sizes: sizeStr
      };
    }

    function galleryAlt(p, file, pos, total) {
      var c = ctxFor(p), i;
      for (i = 0; i < CFG.overrideFiles.length; i++) {
        if (file.indexOf(CFG.overrideFiles[i].match) !== -1) { return CFG.overrideFiles[i].alt; }
      }
      var cf = parseColourFile(file);
      if (cf) {
        return cf.isSwatch ? cf.colour + ' colour swatch for ' + c.brandNoun
                          : c.brand + ' ' + cf.colour + ' ' + c.noun + (cf.size ? ', ' + cf.size + ' bottle' : '');
      }
      var rb = roleBase(file, p);
      if (rb) { for (i = 0; i < ROLES.length; i++) { if (ROLES[i].re.test(rb)) { return ROLES[i].b(c); } } }
      var sp = c.sizes ? (/"|inch/i.test(c.sizes) ? ', available in ' + c.sizes + ' lengths'
                                                  : ', available in ' + c.sizes) : '';
      var noun1 = (c.noun === 'product') ? '' : ', ' + c.brandNoun;
      if (pos === 1) { return c.title + noun1 + sp + ', front view'; }
      return c.title + (c.noun === 'product' ? '' : ', ' + c.noun) + ' - alternate view ' + pos + ' of ' + total;
    }

    function isIconSized(img) { var w = img.getBoundingClientRect().width || img.width || 0; return w > 0 && w <= CFG.iconMaxPx; }
    function isLogo(img) { return /logo/i.test(fileOf(img)) || /logo/i.test(clean(img.getAttribute('alt'))); }
    /* Only treat an alt as a filename if it carries a URL scheme or an image extension -
      product titles legitimately contain slashes, e.g. 'T-Shirt w/ Rear Logo'. */
    function looksLikeFilename(a) { return /^https?:\/\/|^\/\/|\.(jpe?g|png|webp|gif|avif)\b|_\d+x\b/i.test(a); }

    function altIsWeak(img, product) {
      var a = img.getAttribute('alt');
      if (a === null) { return true; }
      a = clean(a);
      if (!a) { return true; }
      if (looksLikeFilename(a)) { return true; }
      if (CFG.thirdPartyAlt[a.toLowerCase()]) { return true; }
      if (product && a.toLowerCase() === clean(product.title).toLowerCase()) { return true; }
      return a.split(' ').length <= 2;
    }

    function nearestHeading(img) {
      var $p = $(img);
      for (var i = 0; i < 8; i++) {
        $p = $p.parent();
        if (!$p.length) { break; }
        var t = clean($p.find('h1,h2,h3,h4,h5,h6').first().text());
        if (t) { return t; }
      }
      return '';
    }

    function getProduct() {
      var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (!m) { return $.Deferred().resolve(null).promise(); }
      return $.getJSON('/products/' + m[1] + '.js').then(function (p) { return p; }, function () { return null; });
    }

    function apply(product) {
      var mediaMap = {}, total = 0, changed = 0, used = {};
      if (product && product.media) {
        total = product.media.length;
        $.each(product.media, function (_, m) { mediaMap[String(m.src).split('?')[0].split('/').pop()] = m.position; });
      }

      $('img').each(function () {
        var img = this, $img = $(img), i;
        if ($img.closest(CFG.skipWithin).length) { return; }
        if (isLogo(img)) { return; }

        var file = fileOf(img), current = img.getAttribute('alt'), next = null;

        var tp = CFG.thirdPartyAlt[clean(current).toLowerCase()];
        if (tp) { if (clean(current) !== tp) { $img.attr('alt', tp); changed++; } return; }

        for (i = 0; i < CFG.overrideFiles.length; i++) {
          if (file.indexOf(CFG.overrideFiles[i].match) !== -1) { next = CFG.overrideFiles[i].alt; break; }
        }

        if (!next && product && mediaMap[file]) {
          next = galleryAlt(product, file, mediaMap[file], total);
          /* same file may appear as main image and thumbnail - that is fine.
            Only disambiguate when two different files would share one alt. */
          if (used[next] && used[next] !== file) { next = next + ' (' + mediaMap[file] + ' of ' + total + ')'; }
          used[next] = file;
        }

        if (!next && $.inArray(clean(current).toLowerCase(), CFG.decorativeAlts) !== -1) {
          $img.attr('alt', '').attr('aria-hidden', 'true'); changed++; return;
        }

        if (!next && !altIsWeak(img, product)) { return; }

        if (!next) {
          var cf = parseColourFile(file);
          var $link = $img.closest('a[href]'), href = $link.length ? String($link.attr('href')) : '';
          var brand = product ? brandOf(product) : CFG.fallbackBrand;

          if (cf && !isIconSized(img)) {
            next = cf.isSwatch ? cf.colour + ' colour swatch'
                              : brand + ' ' + cf.colour + (cf.size ? ' paint, ' + cf.size + ' bottle' : ' paint');
          } else if (href.indexOf('/collections/') === 0) {
            var label = clean($link.text()) || href.split('/').pop().split('?')[0].replace(/-/g, ' ');
            next = 'Shop the ' + label + ' collection';
          } else if (href.indexOf('/products/') === 0) {
            next = clean($link.closest('li,article,div').find('h1,h2,h3,h4,h5,h6').first().text())
                || clean($link.attr('title')) || clean($link.text()) || null;
          } else if (!isIconSized(img)) {
            for (i = 0; i < CFG.fallbackFiles.length; i++) {
              if (file.indexOf(CFG.fallbackFiles[i].match) !== -1) { next = CFG.fallbackFiles[i].alt; break; }
            }
            if (!next && product) {
              var rb2 = roleBase(file, product), c2 = ctxFor(product);
              if (rb2) { for (i = 0; i < ROLES.length; i++) { if (ROLES[i].re.test(rb2)) { next = ROLES[i].b(c2); break; } } }
            }
            if (!next) { var h = nearestHeading(img); if (h) { next = h + ' - Angelus Direct'; } }
          }
        }

        if (next && clean(current) !== clean(next)) { $img.attr('alt', next).removeAttr('aria-hidden'); changed++; }
      });
      return changed;
    }

    $(function () {
      getProduct().then(function (product) {
        apply(product);
        if (window.MutationObserver && !window.__altObserver) {
          var t = null;
          window.__altObserver = new MutationObserver(function () {
            clearTimeout(t); t = setTimeout(function () { apply(product); }, 300);
          });
          window.__altObserver.observe(document.body, { childList: true, subtree: true });
        }
      });
    });
  })(window.jQuery);







/* Accessibility patch — "Frequently bought together" bundle widget (mbc-bundle)
   The widget is injected by XHR ~3-5s after DOMContentLoaded, and the app
   rebuilds its own DOM on every toggle. Nothing here may assume the widget
   exists, or that it will still be the same node a moment later. */
  jQuery(function ($) {

    var SEL_BUNDLE = '.mbc-bundle';
    var seq = 0;

    /* CSS is timing-proof: it applies to nodes that don't exist yet, so the
      checkbox is keyboard-usable the instant the widget paints. */
    if (!$('#a11y-fbt-css').length) {
      $('<style id="a11y-fbt-css">').text([
        '.mbc-checkbox__label{position:relative;display:inline-flex;align-items:center;',
        ' justify-content:center;min-width:24px;min-height:24px;cursor:pointer;}',
        '.mbc-checkbox__input{display:block !important;position:absolute;inset:0;',
        ' width:100%;height:100%;margin:0;opacity:0;cursor:pointer;}',
        '.mbc-checkbox__input:focus-visible + .mbc-checkbox__fake{',
        ' outline:3px solid #1f1f1f;outline-offset:3px;}',
        '.a11y-vh{position:absolute !important;width:1px;height:1px;margin:-1px;padding:0;',
        ' overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}'
      ].join('')).appendTo('head');
    }

    /* Live region lives on <body>, NOT inside the widget — the app would
      delete it on the next re-render. */
    var $live = $('#a11y-fbt-live');
    if (!$live.length) {
      $live = $('<div id="a11y-fbt-live" class="a11y-vh" role="status" ' +
                'aria-live="polite" aria-atomic="true">').appendTo('body');
    }

    function nameFor($item) {
      var $sel = $item.find('select').first();
      if ($sel.length && $sel.find('option:selected').length) {
        return $.trim($sel.find('option:selected').text());
      }
      var title = $.trim($item.find('.mbc-bundle__item-title').first().text());
      return title || $.trim($item.find('img').first().attr('alt') || 'this item');
    }

    function totalFor($bundle) {
      var $price = $bundle.find('.mbc-bundle__price').first();
      var $now = $price.children().not('.mbc-bundle__compare-price').last();
      return $.trim($now.length ? $now.text() : $price.text());
    }

    /* Idempotent: safe to run any number of times, on any number of bundles. */
    function applyNames() {
      $(SEL_BUNDLE).each(function () {
        var $items = $(this).find('.mbc-bundle__item');
        $items.each(function (i) {
          var $item = $(this), name = nameFor($item);

          var $cb = $item.find('input[type="checkbox"]').first();
          if ($cb.length) {
            if (!$cb.attr('id')) $cb.attr('id', 'a11y-fbt-cb-' + (++seq));
            $cb.attr('aria-label', 'Include ' + name + ' in the bundle');
          }

          var $sel = $item.find('select').first();
          if ($sel.length) {
            $sel.attr('aria-label',
              'Choose product ' + (i + 1) + ' of ' + $items.length + ' in the bundle');
          }
        });
      });
    }

    /* Delegated from document so it outlives every re-render of the widget. */
    $(document).off('change.a11yFbt').on('change.a11yFbt',
      '.mbc-bundle input[type="checkbox"]', function () {
        var $cb = $(this), $bundle = $cb.closest(SEL_BUNDLE);
        setTimeout(function () {
          var count = $bundle.find('input[type="checkbox"]:checked').length;
          $live.text(
            nameFor($cb.closest('.mbc-bundle__item')) +
            ($cb.prop('checked') ? ' added to' : ' removed from') + ' the bundle. ' +
            count + ' items selected. Bundle total ' + totalFor($bundle) + '.'
          );
        }, 350);
      });

    /* Watch the whole document, debounced — this is what catches the widget
      arriving late, and every rebuild afterwards. */
    var timer = null;
    function schedule() { clearTimeout(timer); timer = setTimeout(applyNames, 120); }

    applyNames();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  });




/* Add 12 product limit funcationality */

  // (function () {
  //   'use strict';
  //   if (window.AKL && window.AKL.teardown) { try { window.AKL.teardown(); } catch (e) {} }

  //   var A = window.AKL = {};
  //   var C = A.cfg = {
  //     limit: 12,
  //     countMode: 'bottles',   // 'bottles' = sum of quantities | 'colors' = distinct swatches
  //     unit: 'bottle',
  //     groupSelector: '.tpo_option-type-image-swatches-wrapper',
  //     itemSelector: '.tpo_swatches-label_position',
  //     swatchSelector: 'label[role="checkbox"]',
  //     qtyInput: '.tpo_quantity-selector_input',
  //     qtyPlus: '.tpo_quantity-selector_plus',
  //     atcSelector: '.tpo_add-to-cart, button[name="add"]'
  //   };

  //   /* ---------- state ---------- */
  //   A.groups    = function () { return [].slice.call(document.querySelectorAll(C.groupSelector)); };
  //   A.items     = function (g) { return [].slice.call(g.querySelectorAll(C.itemSelector)); };
  //   A.swatch    = function (it) { return it.querySelector(C.swatchSelector); };
  //   A.qty       = function (it) { return it.querySelector(C.qtyInput); };
  //   A.isChecked = function (it) { var s = A.swatch(it); return !!s && s.getAttribute('aria-checked') === 'true'; };
  //   A.qtyVal    = function (it) { var q = A.qty(it), n = q ? parseInt(q.value, 10) : 1; return (!n || n < 1) ? 1 : n; };
  //   A.units     = function (it) { return A.isChecked(it) ? (C.countMode === 'colors' ? 1 : A.qtyVal(it)) : 0; };
  //   A.total     = function (g) { return A.items(g).reduce(function (a, it) { return a + A.units(it); }, 0); };
  //   A.noun      = function (n) { var w = C.countMode === 'colors' ? 'colour' : C.unit; return n === 1 ? w : w + 's'; };
  //   A.uid       = function (p) { return p + Math.floor(Math.random() * 1e6); };

  //   /* ---------- UI ---------- */
  //   A.ui = function (g) {
  //     if (g.__akl && document.contains(g.__akl.wrap)) return g.__akl;
  //     delete g.__akl;

  //     var host = g.parentElement;
  //     [].slice.call(host.children).forEach(function (n) {
  //       if (n.classList && (n.classList.contains('akl-counter') || n.classList.contains('akl-msg') || n.classList.contains('akl-sr'))) n.remove();
  //     });

  //     var wrap  = document.createElement('div');
  //     wrap.className = 'akl-counter';
  //     wrap.id = A.uid('akl-desc-');

  //     var badge = document.createElement('span'); badge.className = 'akl-counter__badge';
  //     var hint  = document.createElement('span'); hint.className  = 'akl-counter__hint';
  //     var prog  = document.createElement('span'); prog.className  = 'akl-progress'; prog.setAttribute('aria-hidden', 'true');
  //     var bar   = document.createElement('span'); bar.className   = 'akl-progress__bar'; bar.style.width = '0%';
  //     prog.appendChild(bar);
  //     wrap.appendChild(badge); wrap.appendChild(hint); wrap.appendChild(prog);

  //     var msg = document.createElement('p'); msg.className = 'akl-msg'; msg.setAttribute('role', 'status');

  //     var live = document.createElement('p');
  //     live.className = 'akl-sr';
  //     live.setAttribute('aria-live', 'polite');
  //     live.setAttribute('aria-atomic', 'true');

  //     host.insertBefore(wrap, g);
  //     host.insertBefore(msg, g);
  //     host.appendChild(live);

  //     g.__akl = { wrap: wrap, badge: badge, hint: hint, bar: bar, msg: msg, live: live, last: '', timer: null };
  //     return g.__akl;
  //   };

  //   A.announce = function (g, text) {
  //     var u = A.ui(g);
  //     if (u.last === text) text += ' ';
  //     u.last = text;
  //     u.live.textContent = text;
  //   };

  //   A.flash = function (g, text, el) {
  //     var u = A.ui(g);
  //     u.msg.textContent = text;
  //     A.announce(g, text);
  //     if (el) { el.classList.add('akl-blocked'); setTimeout(function () { el.classList.remove('akl-blocked'); }, 700); }
  //     clearTimeout(u.timer);
  //     u.timer = setTimeout(function () { u.msg.textContent = ''; }, 6000);
  //   };

  //   /* ---------- sync ---------- */
  //   A.sync = function (g, speak) {
  //     var u = A.ui(g), t = A.total(g), rem = C.limit - t;

  //     u.badge.textContent = t + ' / ' + C.limit + ' selected';
  //     u.bar.style.width   = Math.min(100, (t / C.limit) * 100) + '%';
  //     u.wrap.classList.toggle('is-complete', t === C.limit);
  //     u.wrap.classList.toggle('is-over', t > C.limit);
  //     u.hint.textContent  = t === C.limit ? 'Kit complete.'
  //       : rem > 0 ? 'Choose ' + rem + ' more ' + A.noun(rem) + '.'
  //                 : 'Remove ' + (-rem) + ' ' + A.noun(-rem) + '.';

  //     g.setAttribute('aria-describedby', u.wrap.id);
  //     g.setAttribute('aria-required', 'true');

  //     A.items(g).forEach(function (it) {
  //       var s = A.swatch(it), q = A.qty(it);
  //       if (!s) return;
  //       var checked = A.isChecked(it), lock = !checked && rem <= 0;
  //       it.classList.toggle('akl-locked', lock);
  //       s.setAttribute('aria-disabled', lock ? 'true' : 'false');
  //       if (q) {
  //         var max = C.countMode === 'colors' ? 1 : (checked ? A.qtyVal(it) + rem : rem);
  //         q.setAttribute('max', Math.max(1, Math.min(C.limit, max)));
  //       }
  //     });

  //     [].slice.call(document.querySelectorAll(C.atcSelector)).forEach(function (b) {
  //       var ok = (t === C.limit);
  //       b.classList.toggle('akl-atc-disabled', !ok);
  //       b.setAttribute('aria-disabled', ok ? 'false' : 'true');
  //       b.setAttribute('aria-describedby', u.wrap.id);
  //     });

  //     if (speak) {
  //       A.announce(g, t + ' of ' + C.limit + ' ' + A.noun(C.limit) + ' selected. ' +
  //         (t === C.limit ? 'Selection complete.' : rem > 0 ? rem + ' remaining.' : 'Over the limit by ' + (-rem) + '.'));
  //     }
  //     return t;
  //   };

  //   A.syncAll = function (speak) { A.groups().forEach(function (g) { A.sync(g, speak); }); };

  //   /* ---------- interception (capture phase, runs before the app) ---------- */
  //   function grpOf(n) { return (n && n.closest) ? n.closest(C.groupSelector) : null; }
  //   function stop(e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  //   function fullMsg() { return 'You have already chosen ' + C.limit + ' ' + A.noun(C.limit) + '. Deselect one before adding another.'; }

  //   A.onClick = function (e) {
  //     var g = grpOf(e.target); if (!g) return;
  //     var rem = C.limit - A.total(g);

  //     var sw = e.target.closest(C.swatchSelector);
  //     if (sw && sw.getAttribute('aria-checked') !== 'true' && rem <= 0) { stop(e); A.flash(g, fullMsg(), sw); return; }

  //     var plus = e.target.closest(C.qtyPlus);
  //     if (plus && C.countMode !== 'colors') {
  //       var item = plus.closest(C.itemSelector);
  //       if (item && A.isChecked(item) && rem <= 0) {
  //         stop(e);
  //         A.flash(g, 'Limit reached \u2014 this kit holds exactly ' + C.limit + ' ' + A.noun(C.limit) + '.', plus);
  //         return;
  //       }
  //     }
  //     setTimeout(function () { A.sync(g, true); }, 80);
  //   };

  //   A.onKey = function (e) {
  //     if (e.key !== ' ' && e.key !== 'Spacebar' && e.key !== 'Enter') return;
  //     var g = grpOf(e.target); if (!g) return;
  //     var sw = e.target.closest(C.swatchSelector);
  //     if (sw && sw.getAttribute('aria-checked') !== 'true' && (C.limit - A.total(g)) <= 0) { stop(e); A.flash(g, fullMsg(), sw); return; }
  //     setTimeout(function () { A.sync(g, true); }, 80);
  //   };

  //   A.clamp = function (input) {
  //     var g = grpOf(input); if (!g) return;
  //     var item = input.closest(C.itemSelector); if (!item) return;
  //     var max = Math.max(1, C.limit - (A.total(g) - A.units(item)));
  //     var v = parseInt(input.value, 10); if (!v || v < 1) v = 1;
  //     if (v > max) {
  //       input.value = max;
  //       A.flash(g, 'Reduced to ' + max + ' \u2014 the kit holds exactly ' + C.limit + ' ' + A.noun(C.limit) + '.', input);
  //       input.dispatchEvent(new Event('input',  { bubbles: true }));
  //       input.dispatchEvent(new Event('change', { bubbles: true }));
  //     }
  //     A.sync(g, true);
  //   };

  //   A.onInput = function (e) {
  //     var el = e.target;
  //     if (el && el.matches && el.matches(C.qtyInput)) {
  //       clearTimeout(el.__aklT);
  //       el.__aklT = setTimeout(function () { A.clamp(el); }, 350);
  //     }
  //   };
  //   A.onChange = function (e) {
  //     var el = e.target;
  //     if (el && el.matches && el.matches(C.qtyInput)) A.clamp(el);
  //   };

  //   A.onAtc = function (e) {
  //     var b = e.target.closest(C.atcSelector); if (!b) return;
  //     var g = A.groups()[0]; if (!g) return;
  //     var t = A.total(g); if (t === C.limit) return;
  //     stop(e);
  //     var d = C.limit - t;
  //     A.flash(g, d > 0
  //       ? 'Please choose ' + d + ' more ' + A.noun(d) + ' \u2014 you have ' + t + ' of ' + C.limit + '.'
  //       : 'Please remove ' + (-d) + ' ' + A.noun(-d) + ' \u2014 you have ' + t + ' of ' + C.limit + '.');
  //     var first = g.querySelector(C.swatchSelector);
  //     if (first) { first.scrollIntoView({ block: 'center' }); first.focus(); }
  //   };

  //   document.addEventListener('click',   A.onClick,  true);
  //   document.addEventListener('keydown', A.onKey,    true);
  //   document.addEventListener('input',   A.onInput,  true);
  //   document.addEventListener('change',  A.onChange, true);
  //   document.addEventListener('click',   A.onAtc,    true);

  //   A.mo = new MutationObserver(function () {
  //     clearTimeout(A.moT);
  //     A.moT = setTimeout(function () { A.syncAll(false); }, 200);
  //   });
  //   function observe() {
  //     A.groups().forEach(function (g) {
  //       if (g.__aklObserved) return;
  //       g.__aklObserved = true;
  //       A.mo.observe(g, { attributes: true, attributeFilter: ['aria-checked', 'class'], subtree: true, childList: true });
  //     });
  //   }

  //   A.teardown = function () {
  //     document.removeEventListener('click',   A.onClick,  true);
  //     document.removeEventListener('keydown', A.onKey,    true);
  //     document.removeEventListener('input',   A.onInput,  true);
  //     document.removeEventListener('change',  A.onChange, true);
  //     document.removeEventListener('click',   A.onAtc,    true);
  //     if (A.mo) A.mo.disconnect();
  //     document.querySelectorAll('.akl-counter,.akl-msg,.akl-sr').forEach(function (n) { n.remove(); });
  //     document.querySelectorAll('.akl-locked').forEach(function (n) { n.classList.remove('akl-locked'); });
  //     A.groups().forEach(function (g) { delete g.__akl; delete g.__aklObserved; });
  //   };

  //   function boot() { observe(); A.syncAll(false); }
  //   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  //   document.addEventListener('shopify:section:load', function () { setTimeout(boot, 300); });

  //   // Easify renders asynchronously — retry for the first few seconds
  //   var tries = 0;
  //   var poll = setInterval(function () {
  //     if (A.groups().length) boot();
  //     if (++tries > 20) clearInterval(poll);
  //   }, 500);
  // })();


/*  Wrap the Spurit OCC3 cart drawer content in a landmar   Adjust this selector to the actual outer drawer container */
  // jQuery(function ($) {
  //   // 1. Fix the skip link target — give #root a landmark role
  //   var $mainContent = $('#root');
  //   if ($mainContent.length && !$mainContent.attr('role')) {
  //     $mainContent.attr('role', 'main');
  //   }

  //   // 2. Wrap the Spurit OCC3 cart drawer content in a landmark
  //   //    Adjust this selector to the actual outer drawer container
  //   var $cartDrawer = $('.spurit-occ3__empty-cart-message')
  //     .closest('[class*="occ3"]')       // walks up to the outermost occ3 wrapper
  //     .last();

  //   if ($cartDrawer.length && !$cartDrawer.closest('[role]').length) {
  //     $cartDrawer.attr({
  //       role: 'region',
  //       'aria-label': 'Shopping cart'
  //     });
  //   }
  // });
/*  Product card wrappers on collection/grid pages */

  jQuery(function ($) {
    
    var $cards = $('.card--product-item');

    if (!$cards.length) return;

    $cards.each(function () {
      var $card = $(this);

      // Give each card the required listitem role
      if (!$card.attr('role')) {
        $card.attr('role', 'listitem');
      }

      // Make sure the immediate parent (the grid) is exposed as a list
      var $parent = $card.parent();
      if (!$parent.attr('role')) {
        $parent.attr('role', 'list');
      }
    });
  });

/* Accessibility patch — "Creator Spotlight" blog post cards */
  jQuery(function ($) {

    function patchSpotlight() {
      var $heading = $('h2').filter(function () {
        return /creator spotlight/i.test($(this).text());
      }).first();
      if (!$heading.length) return false;

      var $section = $heading.closest('section');
      if ($section.data('a11yPatched')) return true;
      $section.data('a11yPatched', true);

      var $cards = $section.find('.grid > a');

      $cards.each(function () {
        var $card = $(this);

        /* 1. The card image is decorative in this context — the heading inside
              the same link already states the link purpose. Emptying alt stops
              the title being announced twice (and stops the two long
              descriptive alts from burying the headline entirely). */
        $card.find('img').attr('alt', '');

        /* 2. Demote the card title from h2 to h3 so the six posts nest under
              the section heading instead of sitting beside it. role/aria-level
              re-maps the level without rebuilding the DOM, which keeps the
              theme's typography classes and any Liquid behaviour intact. */
        $card.find('h1,h2,h3,h4,h5').attr({ 'role': 'heading', 'aria-level': '3' });
      });

      /* 3. Give the CTA a destination. The visible text is kept at the start of
            the accessible name so speech-input users can still say
            "Check Them Out" (SC 2.5.3 Label in Name). */
      var $cta = $section.find('a.btn').first();
      if ($cta.length && !$cta.attr('aria-label')) {
        $cta.attr('aria-label', $.trim($cta.text()) + ' — read the Creator Spotlight blog');
      }

      return true;
    }

    /* Run now; retry briefly in case the section is rendered late by the theme. */
    if (!patchSpotlight()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (patchSpotlight() || ++tries > 20) clearInterval(timer);
      }, 250);
    }
  });

/* Accessibility patch — "Works Great On" Flickity carousel */
  jQuery(function ($) {

    if (!$('#a11y-carousel-css').length) {
      $('<style id="a11y-carousel-css">').text([
        /* Restore a visible focus ring; the theme kills it with */
        /* .flickity-enabled:focus { outline: none } */
        '.a11y-carousel:focus-visible{outline:3px solid #1f1f1f !important;',
        '  outline-offset:4px !important;}',
        /* Keep the arrows reachable on small screens too */
        '@media (max-width:767px){.a11y-carousel-arrows{display:flex !important;}}',
        '.a11y-vh{position:absolute !important;width:1px;height:1px;margin:-1px;',
        '  padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}'
      ].join('')).appendTo('head');
    }

    function patchCarousel($heading) {
      var $section  = $heading.closest('section');
      var $carousel = $section.find('[x-ref="slider"]').first();
      var flkty     = window.Flickity && window.Flickity.data($carousel[0]);

      if (!$carousel.length || !flkty || $carousel.data('a11yPatched')) return false;
      $carousel.data('a11yPatched', true);

      /* 1. Carousel semantics + keyboard entry point.
            tabindex="0" also switches on Flickity's built-in Left/Right key
            handling (options.accessibility is already true), so do NOT bind
            your own arrow keys here or every press will move two slides. */
      var headingId = $heading.attr('id') || 'a11y-carousel-heading';
      $heading.attr('id', headingId);
      $carousel
        .addClass('a11y-carousel')
        .attr({
          'id': $carousel.attr('id') || 'a11y-carousel-works-great-on',
          'role': 'region',
          'aria-roledescription': 'carousel',
          'aria-labelledby': headingId,
          'tabindex': '0'
        });
      var carouselId = $carousel.attr('id');

      /* 2. Label every slide with its position */
      var $cells = $carousel.find('.flickity-slider').children();
      var total  = $cells.length;
      $cells.each(function (i) {
        $(this).attr({
          'role': 'group',
          'aria-roledescription': 'slide',
          'aria-label': (i + 1) + ' of ' + total
        });
      });

      /* 3. Polite status region so slide changes are announced */
      var $live = $('<div class="a11y-vh" role="status" aria-live="polite" aria-atomic="true">')
                    .appendTo($section);

      /* 4. Repair the arrow buttons */
      var $arrows = $section.find('button[title$="slide"]');
      var $prev   = $arrows.filter('[title*="Previous"]');
      var $next   = $arrows.filter('[title*="Next"]');

      $arrows
        .attr({ 'type': 'button', 'aria-controls': carouselId })
        .find('svg').attr({ 'aria-hidden': 'true', 'focusable': 'false' });
      $prev.attr('aria-label', 'Previous slide');
      $next.attr('aria-label', 'Next slide');
      $arrows.closest('.sider-arrows').addClass('a11y-carousel-arrows');

      /* 5. Announce position and expose the end-of-list state */
      function sync() {
        var i     = flkty.selectedIndex;
        var title = $.trim($cells.eq(i).find('h3').first().text()) || ('Slide ' + (i + 1));
        $live.text(title + ', slide ' + (i + 1) + ' of ' + total);
        $prev.attr('aria-disabled', i === 0 ? 'true' : 'false');
        $next.attr('aria-disabled', i >= total - 1 ? 'true' : 'false');
      }
      flkty.on('change', sync);
      sync();

      /* 6. Home / End jump to the ends (Flickity doesn't handle these) */
      $carousel.on('keydown.a11yCarousel', function (e) {
        if (e.key === 'Home')     { flkty.select(0);         e.preventDefault(); }
        else if (e.key === 'End') { flkty.select(total - 1); e.preventDefault(); }
      });

      return true;
    }

    /* Flickity is initialised inside an Alpine x-init setTimeout, so poll
      briefly rather than assuming it exists on DOM ready. */
    var tries = 0;
    var timer = setInterval(function () {
      var $h = $('h2').filter(function () {
        return /works great on/i.test($(this).text());
      }).first();
      if (($h.length && patchCarousel($h)) || ++tries > 40) clearInterval(timer);
    }, 250);
  });



/* Accessibility patch for Shopify privacy banner + preferences dialog */
  jQuery(function ($) {

    function patchBanner() {
      var $banner = $('#shopify-pc__banner');
      if (!$banner.length || $banner.data('a11yPatched')) return;
      $banner.data('a11yPatched', true);

      /* 1. Associate the description with the alertdialog, and make it focusable */
      $banner.find('.shopify-pc__banner__body p').first().attr('id', 'shopify-pc__banner__body-desc');
      $banner.attr({
        'aria-describedby': 'shopify-pc__banner__body-desc',
        'tabindex': '-1'
      });

      /* 2. Move focus into the alertdialog so it is announced, without stealing
            focus from a user who is already typing */
      setTimeout(function () {
        if (document.activeElement === document.body) $banner.trigger('focus');
      }, 400);

      /* 3. Warn that the policy link opens a new tab */
      var $link = $('#shopify-pc__banner__body-policy-link');
      if ($link.length && !$link.find('.a11y-vh').length) {
        $link.append('<span class="a11y-vh"> (opens in a new tab)</span>');
      }
    }

    function patchPrefs() {
      var $prefs = $('#shopify-pc__prefs__dialog');
      if (!$prefs.length || $prefs.data('a11yPatched')) return;
      $prefs.data('a11yPatched', true);

      /* 4. Keep the locked "Required" toggle reachable and correctly announced */
      $('#shopify-pc__prefs__essential-input')
        .attr({ 'tabindex': '0', 'aria-disabled': 'true' })
        .removeAttr('aria-readonly')
        .on('keydown click', function (e) {
          if (e.type === 'click' || e.key === ' ') { e.preventDefault(); }
        });

      /* 5. Tie each option's explanatory text to its checkbox */
      $prefs.find('input[type="checkbox"]').each(function (i) {
        var $row  = $(this).closest('li, .shopify-pc__prefs__option, div');
        var $desc = $row.find('p').first();
        if (!$desc.length) return;
        var id = $desc.attr('id') || ('a11y-pc-desc-' + i);
        $desc.attr('id', id);
        $(this).attr('aria-describedby', id);
      });
    }

    /* 6. High-contrast focus indicator (3:1+) for both dialogs */
    if (!$('#a11y-consent-focus').length) {
      $('<style id="a11y-consent-focus">').text([
        '.shopify-pc__banner__dialog button:focus,',
        '.shopify-pc__prefs__dialog button:focus,',
        '.shopify-pc__prefs__dialog input:focus{',
        '  outline:3px solid #1f1f1f !important;',
        '  outline-offset:2px !important;',
        '  box-shadow:0 0 0 5px #fff, 0 0 0 8px #1f1f1f !important;}',
        '.shopify-pc__banner__dialog button.shopify-pc__banner__btn-manage-prefs:focus span{',
        '  outline:none !important;}',
        '.shopify-pc__banner__body p a:focus{',
        '  outline:3px solid #1f1f1f !important;',
        '  outline-offset:2px !important;',
        '  box-shadow:none !important;}',
        '#shopify-pc__banner:focus{outline:none;}',
        '.a11y-vh{position:absolute !important;width:1px;height:1px;margin:-1px;',
        '  padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}'
      ].join('')).appendTo('head');
    }

    /* The banner and prefs dialog are injected asynchronously by Shopify,
      so watch for them rather than running once on ready. */
    patchBanner(); patchPrefs();
    new MutationObserver(function () { patchBanner(); patchPrefs(); })
      .observe(document.body, { childList: true, subtree: true });
  });



// ============================== product page "Frequently bought together"  dialog box add product ================================================================================

  (function ($) {
    $(function () {

      // ============================================================
      // Shared live region (used for both modal and selection announcements)
      // ============================================================
      if (!$('#picker-live-status').length) {
        $('<div>', {
          id: 'picker-live-status', role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true',
          css: { position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px',
                overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: '0' }
        }).appendTo('body');
      }

      function announce(message) {
        var $status = $('#picker-live-status');
        $status.text('');
        setTimeout(function () { $status.text(message); }, 50);
      }

      function focusChooseButton() {
        var $chooseBtn = $('.mbc-bundles-resource-picker__button-choose').first();
        if ($chooseBtn.length) {
          setTimeout(function () {
            $chooseBtn.trigger('focus');
          }, 50);
        }
      }


      // ============================================================
      // Modal: focus trap, Escape to close, accessible names
      // ============================================================
      var lastFocusedBeforeOpen = null;
      var openTriggerElement = null; // dedicated reference, separate from lastFocusedBeforeOpen

      function getFocusable($modal) {
        return $modal.find(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ).filter(':visible');
      }

      function openModal($modal) {
        lastFocusedBeforeOpen = document.activeElement;
        openTriggerElement = document.activeElement; // capture explicitly at open time

        if (!$modal.attr('aria-label') && !$modal.attr('aria-labelledby')) {
          var $title = $modal.find('.mbc-modal__title').first();
          var titleText = $.trim($title.text());
          $modal.attr('aria-label', titleText || 'Select an option');
        }
        $modal.attr('aria-modal', 'true');

        var $closeBtn = $modal.find('.mbc-modal__close').first();
        if ($closeBtn.length && !$closeBtn.attr('aria-label')) {
          $closeBtn.attr('aria-label', 'Close dialog');
        }

        setTimeout(function () {
          var $focusable = getFocusable($modal);
          if ($focusable.length) {
            $focusable.first().trigger('focus');
          } else {
            $modal.trigger('focus');
          }
        }, 50);

        $(document).off('keydown.mbcModalTrap').on('keydown.mbcModalTrap', function (e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeModal($modal);
            return;
          }

          if (e.key !== 'Tab') return;

          var $focusable = getFocusable($modal);
          if (!$focusable.length) return;

          var first = $focusable[0];
          var last = $focusable[$focusable.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
      }

      function closeModal($modal) {
          var $closeBtn = $modal.find('.mbc-modal__close').first();
          if ($closeBtn.length) {
            $closeBtn[0].click();
          }

          $(document).off('keydown.mbcModalTrap');

          if (openTriggerElement && document.body.contains(openTriggerElement)) {
            setTimeout(function () {
              openTriggerElement.focus();
            }, 50);
          }
        }

      // Watch for the modal being inserted into the DOM, or its data-state flipping
      var modalObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            var $node = $(node);
            var $modal = $node.is('.mbc-modal') ? $node : $node.find('.mbc-modal').first();
            if ($modal.length && $modal.attr('data-state') === 'open') {
              openModal($modal);
            }
          });

          if (m.type === 'attributes' && m.attributeName === 'data-state') {
            var $target = $(m.target);
            if ($target.is('.mbc-modal')) {
              if ($target.attr('data-state') === 'open') {
                openModal($target);
              } else {
                $(document).off('keydown.mbcModalTrap');
              }
            }
          }
        });
      });

      modalObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-state']
      });


      // ============================================================
      // Resource picker: role="listbox"/"option", arrow-key grid navigation,
      // Enter/Space to select, selection announcement
      // ============================================================
      function enhanceResourcePicker($ul) {
        if ($ul.data('a11yPickerDone')) return;
        $ul.data('a11yPickerDone', true);

        $ul.attr({
          role: 'listbox',
          'aria-label': 'Select a color'
        });

        var $items = $ul.find('.mbc-bundles-resource-picker__item');

        function itemsPerRow() {
          if ($items.length < 2) return 1;
          var firstTop = $items.eq(0).offset().top;
          var count = 1;
          for (var i = 1; i < $items.length; i++) {
            if ($items.eq(i).offset().top !== firstTop) break;
            count++;
          }
          return count;
        }

        $items.each(function (i) {
          var $item = $(this);
          var title = $.trim($item.find('.mbc-bundles-resource-picker__item-title').text());

          $item.attr({
            role: 'option',
            tabindex: i === 0 ? '0' : '-1',
            'aria-selected': 'false',
            'aria-label': title
          });
        });

        function setFocus(index) {
          var count = $items.length;
          index = ((index % count) + count) % count;
          $items.attr('tabindex', '-1');
          $items.eq(index).attr('tabindex', '0').trigger('focus');
        }

        function currentIndex() {
          var idx = $items.index($items.filter(function () {
            return this === document.activeElement;
          }));
          return idx === -1 ? 0 : idx;
        }

        function selectItem($item) {
          $items.attr('aria-selected', 'false');
          $item.attr('aria-selected', 'true');

          $item[0].click();

          announce($.trim($item.find('.mbc-bundles-resource-picker__item-title').text()) + ' selected.');

          // If this selection closes the modal, make sure focus still lands
          // on the Choose button (closeModal() may not always run this path)
          setTimeout(function () {
            if (!$('.mbc-modal[data-state="open"]').length) {
              focusChooseButton();
            }
          }, 150);
        }

        $ul.on('keydown', '.mbc-bundles-resource-picker__item', function (e) {
          var perRow = itemsPerRow();
          var idx = currentIndex();

          if (e.key === 'ArrowRight') {
            e.preventDefault();
            setFocus(idx + 1);
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            setFocus(idx - 1);
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            setFocus(idx + perRow);
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setFocus(idx - perRow);
          } else if (e.key === 'Home') {
            e.preventDefault();
            setFocus(0);
          } else if (e.key === 'End') {
            e.preventDefault();
            setFocus($items.length - 1);
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectItem($(this));
          }
        });

        $ul.on('click', '.mbc-bundles-resource-picker__item', function () {
          selectItem($(this));
        });
      }

      // Picker is injected dynamically when the modal opens — watch for it
      $('.mbc-bundles-resource-picker').each(function () { enhanceResourcePicker($(this)); });

      var pickerObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            var $node = $(node);
            if ($node.is('.mbc-bundles-resource-picker')) enhanceResourcePicker($node);
            $node.find('.mbc-bundles-resource-picker').each(function () { enhanceResourcePicker($(this)); });
          });
        });
      });
      pickerObserver.observe(document.body, { childList: true, subtree: true });

    });
  })(jQuery);


// ============================== product page "Frequently bought together" ================================================================================

  jQuery(function ($) {
    var GROUP_SELECTOR = '.mbc-bundle__swatch-element-list';
    var ITEM_SELECTOR  = '.mbc-bundle__swatch-element';

    // 1. Initialize ARIA roles/states on existing and future swatch groups
    function initGroup($group) {
      if ($group.data('a11y-init')) return;
      $group.data('a11y-init', true);

      $group.attr('role', 'radiogroup');

      $group.find(ITEM_SELECTOR).each(function () {
        var $item  = $(this);
        var $input = $item.find('input[type="radio"]');
        var $label = $item.find('label[for="' + $input.attr('id') + '"]');

        if (!$input.length || !$label.length) return;

        $label
          .attr('role', 'radio')
          .attr('tabindex', $input.is(':checked') ? '0' : '-1')
          .attr('aria-checked', $input.is(':checked') ? 'true' : 'false');
      });
    }

    // 2. Select a given option: check the real input, fire native events so
    //    the existing bundle app logic reacts exactly as it does on click,
    //    then sync aria-checked/tabindex across the group.
    function selectOption($label) {
      var $group = $label.closest(GROUP_SELECTOR);
      var $input = $('#' + $label.attr('for'));
      if (!$input.length || $input.is(':checked')) {
        $label.trigger('focus');
        return;
      }

      $input.prop('checked', true).trigger('click').trigger('change');

      $group.find('label[role="radio"]').each(function () {
        var $l = $(this);
        var checked = $('#' + $l.attr('for')).is(':checked');
        $l.attr('aria-checked', checked ? 'true' : 'false')
          .attr('tabindex', checked ? '0' : '-1');
      });

      $label.trigger('focus');
    }

    // 3. Keyboard support: Enter/Space activates; Left/Up and Right/Down
    //    move between options like a native radio group.
    $(document).on('keydown', GROUP_SELECTOR + ' label[role="radio"]', function (e) {
      var $label = $(this);
      var $items = $label.closest(GROUP_SELECTOR).find('label[role="radio"]');
      var idx = $items.index($label);

      switch (e.key) {
        case 'Enter':
        case ' ':
        case 'Spacebar':
          e.preventDefault();
          selectOption($label);
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          selectOption($items.eq((idx + 1) % $items.length));
          break;

        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          selectOption($items.eq((idx - 1 + $items.length) % $items.length));
          break;
      }
    });

    // Keep aria-checked in sync if the input is ever changed via mouse click too
    $(document).on('change', GROUP_SELECTOR + ' input[type="radio"]', function () {
      var $group = $(this).closest(GROUP_SELECTOR);
      $group.find('label[role="radio"]').each(function () {
        var $l = $(this);
        var checked = $('#' + $l.attr('for')).is(':checked');
        $l.attr('aria-checked', checked ? 'true' : 'false')
          .attr('tabindex', checked ? '0' : '-1');
      });
    });

    // 4. Initialize now, and watch for dynamically rendered groups
    //    (the widget is Vue-rendered and may (re)mount after page load)
    $(GROUP_SELECTOR).each(function () { initGroup($(this)); });

    var observer = new MutationObserver(function () {
      $(GROUP_SELECTOR).each(function () { initGroup($(this)); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });


// ============================== picking 3/6/12 paint bottles accessible ================================================================================

  // (function ($) {
  //   'use strict';

  //   function simulateActivate(el) {
  //     var opts = { bubbles: true, cancelable: true, composed: true };
  //     el.dispatchEvent(new PointerEvent('pointerdown', opts));
  //     el.dispatchEvent(new MouseEvent('mousedown', opts));
  //     el.dispatchEvent(new PointerEvent('pointerup', opts));
  //     el.dispatchEvent(new MouseEvent('mouseup', opts));
  //     el.dispatchEvent(new MouseEvent('click', opts));
  //   }

  //   function labelText($label, $input) {
  //     var val = ($input.val() || '').trim();
  //     return val || $label.text().trim() || 'swatch option';
  //   }

  //   function syncState($label, $input) {
  //     var checked = $input.prop('checked');
  //     var disabled = $input.prop('disabled');
  //     $label.attr('aria-checked', checked ? 'true' : 'false');
  //     if (disabled && !checked) {
  //       $label.attr('aria-disabled', 'true').attr('tabindex', '-1');
  //     } else {
  //       $label.removeAttr('aria-disabled').attr('tabindex', '0');
  //     }
  //   }

  //   function refreshSwatchA11y() {
  //     // Label the group so screen readers announce "Tap 3 Bottles to Select" once, on entry
  //     var $wrapper = $('.tpo_option-type-image-swatches-wrapper');
  //     var $heading = $('.tpo_option-label-container .form__label').first();
  //     if ($wrapper.length && $heading.length && !$wrapper.attr('role')) {
  //       $wrapper.attr({ role: 'group', 'aria-label': $heading.text().trim() });
  //     }

  //     $('.tpo_option-type-image-swatches-wrapper label[class*="tpo_shape_"]').each(function () {
  //       var $label = $(this);
  //       var $input = $label.find('input[type="checkbox"], input[type="radio"]').first();
  //       if (!$input.length) { return; }

  //       if (!$label.data('a11yBound')) {
  //         $label.data('a11yBound', true);
  //         $label.attr('role', $input.attr('type') === 'radio' ? 'radio' : 'checkbox');
  //         $label.attr('aria-label', labelText($label, $input));

  //         $label.on('keydown.a11ySwatch', function (e) {
  //           var key = e.key || '';
  //           if (key === 'Enter' || key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
  //             e.preventDefault();
  //             if ($label.attr('aria-disabled') === 'true') { return; }
  //             simulateActivate(this);
  //             setTimeout(function () { syncState($label, $input); }, 60);
  //           }
  //         });

  //         $input.on('change.a11ySwatch click.a11ySwatch', function () {
  //           setTimeout(function () { syncState($label, $input); }, 60);
  //         });
  //       }

  //       syncState($label, $input);
  //     });
  //   }

  //   $(function () {
  //     refreshSwatchA11y();
  //     var root = document.querySelector('.tpo_option-set-container') || document.body;
  //     if (window.MutationObserver) {
  //       new MutationObserver(refreshSwatchA11y).observe(root, { childList: true, subtree: true });
  //     }
  //   });

  // })(jQuery);



/* Accessible, WCAG/ADA-aligned fixes for the Sort / Product type / Color filter bar.
   Tested live: filtering still works, and does not fire on every arrow keypress. */
  // (function ($) {
  //   "use strict";

  //   // ---------- 5: Debounce the actual filter commit (does NOT block the event) ----------
  //   function patchFilterDebounce() {
  //     if (!window.Alpine) return;
  //     var data = window.Alpine.$data(document.documentElement);
  //     if (!data || data.__a11yPatched || typeof data.handleFilterChange !== "function") return;
  //     data.__a11yPatched = true;

  //     var original = data.handleFilterChange.bind(data);
  //     // Reuses the theme's own debounce() utility so behavior matches the rest of the app
  //     data.handleFilterChange = data.debounce(function (id) {
  //       original(id);
  //     }, 350);
  //   }

  //   // ---------- 4: Enter key toggles checkboxes, same as Space ----------
  //   document.addEventListener(
  //     "keydown",
  //     function (e) {
  //       if (e.key === "Enter" && e.target.matches('input[type="checkbox"]')) {
  //         e.preventDefault();
  //         e.target.click(); // real click -> toggles checked + fires change normally
  //       }
  //     },
  //     true
  //   );

  //   // ---------- 1, 2, 3: ARIA state + Escape-to-close + focus-out-to-close ----------
  //   function setupDropdown(wrapper) {
  //     if (wrapper.dataset.a11yDone) return;
  //     var btn = wrapper.querySelector(":scope > div > button");
  //     var panel = wrapper.querySelector(":scope > [x-show]");
  //     if (!btn || !panel) return;
  //     wrapper.dataset.a11yDone = "true";

  //     var id = panel.id || "filter-panel-" + Math.random().toString(36).slice(2);
  //     panel.id = id;

  //     btn.setAttribute("aria-haspopup", "true");
  //     btn.setAttribute("aria-controls", id);
  //     btn.setAttribute("aria-expanded", panel.offsetParent !== null ? "true" : "false");
  //     panel.setAttribute("role", "group");
  //     panel.setAttribute("aria-label", $.trim(btn.textContent));

  //     // Keep aria-expanded accurate no matter what closes/opens the panel
  //     new MutationObserver(function () {
  //       btn.setAttribute("aria-expanded", panel.offsetParent !== null ? "true" : "false");
  //     }).observe(panel, { attributes: true, attributeFilter: ["style", "class"] });

  //     wrapper.addEventListener("keydown", function (e) {
  //       if (e.key === "Escape" && panel.offsetParent !== null) {
  //         e.stopPropagation();
  //         btn.click(); // reuses Alpine's own toggle (closes since it's open)
  //         btn.focus(); // WCAG 2.4.3: return focus to a sensible, predictable place
  //       }
  //     });

  //     wrapper.addEventListener("focusout", function (e) {
  //       if (panel.offsetParent !== null && (!e.relatedTarget || !wrapper.contains(e.relatedTarget))) {
  //         btn.click();
  //       }
  //     });
  //   }

  //   function scanDropdowns() {
  //     document.querySelectorAll("[x-data]").forEach(function (w) {
  //       var btn = w.querySelector(":scope > div > button");
  //       var panel = w.querySelector(":scope > [x-show]");
  //       if (btn && panel) setupDropdown(w);
  //     });
  //   }

  //   // ---------- 6: Visible + announced filter/result summary ----------
  //   var $summary;
  //     function ensureSummaryEl() {
  //       if ($summary && $summary.closest("body").length) return $summary;
  //       var $anchor = $("#js-desktopFilter").first();
  //       if (!$anchor.length) return $();
  //       $summary = $('<p class="type--small color__text-subdued mt-2" role="status" aria-live="polite" style="display:none"></p>');
  //       $anchor.after($summary);
  //       return $summary;
  //   }

  //   function updateSummary() {
  //     var $form = $("#js-desktopFilter");
  //     if (!$form.length) return;

  //     var sortLabel = $.trim($form.find('input[name="sort_by"]:checked').closest("label").text());
  //     var filterLabels = [];
  //     $form.find('input[type="checkbox"]:checked').each(function () {
  //       var label = $.trim($(this).closest("label").find("span").first().text());
  //       if (label) filterLabels.push(label);
  //     });

  //     // var count = $("[data-results-count]").first().attr("data-results-count");
  //     // if (count == null) count = $('a[href*="/products/"]', $form.closest("section")).length || "";


  //     var $ProductCount = $('#filtered-product-count');
  //     var text12 = $ProductCount.text();

  //     var parts = [];
  //     if (sortLabel) parts.push("Sort: " + sortLabel);
  //     if (filterLabels.length) parts.push("Filters: " + filterLabels.join(", "));
  //     parts.push("Products found: " + text12 );

  //     var $el = ensureSummaryEl();
  //     if ($el.length) $el.text(parts.join(" \u2014 "));
  //   }

  //   function init() {
  //     patchFilterDebounce();
  //     scanDropdowns();
  //     updateSummary();
  //   }

  //   $(function () {
  //     init();
  //     var mo = new MutationObserver(function () {
  //       clearTimeout(mo._t);
  //       mo._t = setTimeout(init, 50); // re-run after each AJAX section refresh
  //     });
  //     document.querySelectorAll('[id^="shopify-section-"]').forEach(function (s) {
  //       mo.observe(s, { childList: true, subtree: false });
  //     });
  //   });
  // })(jQuery);



// ============================== Search dialog issue fixed ================================================================================



    $(document).ready(function () {

      // ═══════════════════════════════════════════════════════════════════
      //  WCAG 2.1 COMPLIANT SEARCH DIALOG  (jQuery — Complete Final Script)
      //
      //  SC 3.2.1  On Focus      — dialog only opens on input, not focus
      //  SC 2.1.1  Keyboard      — full keyboard support
      //  SC 2.4.3  Focus Order   — logical focus sequence
      //  SC 2.4.7  Focus Visible — outline on every keyboard-navigated item
      //  SC 4.1.2  Name/Role/Val — ARIA roles, aria-selected, aria-expanded
      //  SC 1.3.1  Info & Rels   — listbox / option roles
      //  SC 4.1.3  Status Msgs   — aria-live result announcements
      //  + Focus Trap  (ARIA APG Dialog Pattern)
      //  + Esc to close
      // ═══════════════════════════════════════════════════════════════════

      // ── Selectors & helpers ────────────────────────────────────────────

      const FOCUSABLE_SEL = [
        'a[href]', 'button:not([disabled])',
        'input:not([disabled])', 'select:not([disabled])',
        'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
      ].join(', ');

      const $desktopInput = $('#search-desktop');
      const $mobileInput  = $('#search-mobile');
      const nav           = document.querySelector('nav[x-data]');

      function getNavData() {
        return window.Alpine ? Alpine.$data(nav) : null;
      }

      // Returns the VISIBLE desktop or mobile dropdown (whichever is open)
      function $activeDropdown() {
        return $('div[x-show="search_active"]:visible').filter(function () {
          return $(this).find('a, button').length > 0;
        }).first();
      }

      // All navigable suggestion anchors in order (queries first, then products)
      function $allSuggestions() {
        return $activeDropdown().find('a[href]');
      }

      function closeSearch() {
        const navData = getNavData();
        if (!navData) return;
        navData.search_active = false;
        // Return focus to whichever search input is visible
        ($desktopInput.is(':visible') ? $desktopInput : $mobileInput).trigger('focus');
      }

      // ── CSS: keyboard focus outline injected once ──────────────────────
      //
      //  .wcag-search-focused  →  applied by jQuery to the arrow-key item
      //  Overrides the theme's existing underline/bg highlight with a
      //  proper, clearly-visible 3px focus ring (WCAG 2.4.7 / 2.4.11)

      if (!$('#wcag-search-styles').length) {
        $('<style id="wcag-search-styles">').text(`

          /* Keyboard-navigated suggestion item (both queries and products) */
          .wcag-search-focused {
            outline: 3px solid #005fcc !important;   /* high-contrast blue ring  */
            outline-offset: 2px         !important;
            border-radius: 4px          !important;
            background-color: rgba(0, 95, 204, 0.08) !important;
            text-decoration: none       !important;
          }

          /* Remove browser default :focus outline on suggestion anchors
            only when our custom class is managing focus visibility        */
          #search-results-desktop a:focus,
          #search-results-mobile  a:focus {
            outline: none;
          }

          /* Keep :focus-visible on the search input itself intact          */
          #search-desktop:focus-visible,
          #search-mobile:focus-visible {
            outline: 3px solid #005fcc;
            outline-offset: 2px;
          }

        `).appendTo('head');
      }

      // ── 1. Remove Alpine's @focus listener ────────────────────────────
      //  Prevents the dialog opening when the user merely Tabs to the field
      //  WCAG SC 3.2.1 On Focus

      ['#search-desktop', '#search-mobile'].forEach(function (sel) {
        const el = document.querySelector(sel);
        if (!el) return;
        const cleanups = el._x_attributeCleanups;
        if (cleanups && cleanups['@focus']) {
          cleanups['@focus'].forEach(fn => fn());
          delete cleanups['@focus'];
        }
      });

      // ── 2. Open dialog only when the user types ────────────────────────

      $desktopInput.add($mobileInput).on('input.wcag', function () {
        const navData = getNavData();
        if (!navData) return;
        navData.search_active = $(this).val().trim().length > 0;
      });

      // ── 3. ESC → close dialog, return focus to input ──────────────────

      $(document).on('keydown.wcag-esc', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        const navData = getNavData();
        if (navData && navData.search_active) {
          e.preventDefault();
          closeSearch();
        }
      });

      // ── 4. Arrow ↓ / ↑ — focus outline on suggestion items ───────────
      //
      //  Alpine already updates search_focus_index via @keyup.down/up on
      //  the input.  We hook the same events AFTER Alpine runs to:
      //    a) remove the outline class from the previously focused item
      //    b) add it to the newly focused item
      //    c) set aria-selected on the item
      //    d) scroll it into view

      $desktopInput.add($mobileInput).on('keyup.wcag-arrow', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

        const navData = getNavData();
        if (!navData || !navData.search_active) return;

        // Let Alpine finish its synchronous update first
        requestAnimationFrame(function () {
          const idx          = navData.search_focus_index;   // 0-based, set by Alpine
          const $suggestions = $allSuggestions();

          // Clear previous outline + aria-selected
          $suggestions
            .removeClass('wcag-search-focused')
            .attr('aria-selected', 'false')
            .removeAttr('tabindex');

          // Apply to newly focused item
          const $focused = $suggestions.eq(idx);
          if ($focused.length) {
            $focused
              .addClass('wcag-search-focused')
              .attr('aria-selected', 'true')
              .attr('tabindex', '-1');   // allows programmatic focus without tab-stop

            // Scroll into view if clipped
            $focused[0].scrollIntoView({ block: 'nearest' });

            // Update aria-activedescendant on the input so screen readers
            // announce the focused suggestion automatically
            const itemId = 'search-item-' + idx;
            $focused.attr('id', itemId);
            ($desktopInput.is(':visible') ? $desktopInput : $mobileInput)
              .attr('aria-activedescendant', itemId);
          }
        });
      });

      // Clear outline + aria-activedescendant when user starts typing again
      $desktopInput.add($mobileInput).on('input.wcag-arrow-clear', function () {
        $allSuggestions()
          .removeClass('wcag-search-focused')
          .attr('aria-selected', 'false');
        $(this).removeAttr('aria-activedescendant');
      });

      // ── 5. Focus trap (Tab / Shift+Tab inside open dialog) ────────────

      $(document).on('keydown.wcag-trap', function (e) {
        if (e.key !== 'Tab') return;
        const navData = getNavData();
        if (!navData || !navData.search_active) return;

        const $dialog    = $activeDropdown();
        if (!$dialog.length) return;

        const $visInput  = $desktopInput.is(':visible') ? $desktopInput : $mobileInput;
        const $focusable = $dialog.find(FOCUSABLE_SEL).add($visInput).filter(':visible');
        if (!$focusable.length) return;

        const $first  = $focusable.first();
        const $last   = $focusable.last();
        const $active = $(document.activeElement);

        if (e.shiftKey) {
          if ($active.is($first) || !$focusable.is($active)) {
            e.preventDefault();
            $last.trigger('focus');
          }
        } else {
          if ($active.is($last) || !$focusable.is($active)) {
            e.preventDefault();
            $first.trigger('focus');
          }
        }
      });

      // ── 6. Backdrop click → close ─────────────────────────────────────

      $(document).on('click.wcag-backdrop', function (e) {
        const navData = getNavData();
        if (!navData || !navData.search_active) return;
        const $t = $(e.target);
        if (!$t.closest('div[x-show="search_active"]').length &&
            !$t.is('#search-desktop, #search-mobile')) {
          closeSearch();
        }
      });

      // ── 7. Blur empty input → close ───────────────────────────────────

      $desktopInput.add($mobileInput).on('blur.wcag', function () {
        const $input = $(this);
        setTimeout(function () {
          const navData = getNavData();
          if (!navData) return;
          const $f = $(document.activeElement);
          if ($input.val().trim() === '' &&
              !$f.closest('div[x-show="search_active"]').length &&
              !$f.is('#search-desktop, #search-mobile')) {
            navData.search_active = false;
          }
        }, 200);
      });

      // ── 8. ARIA on inputs (SC 4.1.2) ─────────────────────────────────

      $desktopInput.attr({
        role:                  'combobox',
        'aria-expanded':       'false',
        'aria-autocomplete':   'list',
        'aria-label':          'Search products',
        'aria-haspopup':       'listbox',
        'aria-controls':       'search-results-desktop',
        'aria-activedescendant': ''
      });

      $mobileInput.attr({
        role:                  'combobox',
        'aria-expanded':       'false',
        'aria-autocomplete':   'list',
        'aria-label':          'Search products',
        'aria-haspopup':       'listbox',
        'aria-controls':       'search-results-mobile',
        'aria-activedescendant': ''
      });

      // ── 9. Role on result containers + option roles on items ──────────
      //  Applied via MutationObserver so it catches Alpine re-renders

      function applyItemRoles($dropdown) {
        $dropdown.find('a[href]').each(function (i) {
          $(this).attr({
            role:          'option',
            'aria-selected': 'false'
          });
        });
      }

      $('div[x-show="search_active"]').each(function (i) {
        if (i === 0) {
          $(this).attr({ id: 'search-results-mobile',  role: 'listbox', 'aria-label': 'Search suggestions' });
          applyItemRoles($(this));
        } else if (i === 2) {
          $(this).attr({ id: 'search-results-desktop', role: 'listbox', 'aria-label': 'Search suggestions', 'aria-modal': 'true' });
          applyItemRoles($(this));
        }
      });

      // Re-apply option roles after Alpine updates the list
      const itemRoleObserver = new MutationObserver(function () {
        const $d = $('#search-results-desktop');
        const $m = $('#search-results-mobile');
        if ($d.length) applyItemRoles($d);
        if ($m.length) applyItemRoles($m);
      });

      ['#search-results-desktop', '#search-results-mobile'].forEach(function (sel) {
        const el = document.querySelector(sel);
        if (el) itemRoleObserver.observe(el, { childList: true, subtree: true });
      });

      // ── 10. Sync aria-expanded ─────────────────────────────────────────

      function syncAriaExpanded() {
        const dOpen = $('#search-results-desktop').css('display') !== 'none';
        const mOpen = $('#search-results-mobile').css('display')  !== 'none';
        $desktopInput.attr('aria-expanded', dOpen ? 'true' : 'false');
        $mobileInput.attr( 'aria-expanded', mOpen ? 'true' : 'false');

        // Clear focus outline + activedescendant when dialog closes
        if (!dOpen && !mOpen) {
          $('a.wcag-search-focused').removeClass('wcag-search-focused');
          $desktopInput.removeAttr('aria-activedescendant');
          $mobileInput.removeAttr('aria-activedescendant');
        }
      }

      const expandedObserver = new MutationObserver(syncAriaExpanded);
      ['#search-results-desktop', '#search-results-mobile'].forEach(function (sel) {
        const el = document.querySelector(sel);
        if (el) expandedObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
      });

      // ── 11. aria-live status region (SC 4.1.3) ────────────────────────

      if (!$('#search-live-status').length) {
        $('<div>', {
          id: 'search-live-status', role: 'status',
          'aria-live': 'polite', 'aria-atomic': 'true',
          css: {
            position: 'absolute', width: '1px', height: '1px',
            padding: '0', margin: '-1px', overflow: 'hidden',
            clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: '0'
          }
        }).appendTo('body');
      }

      const desktopResultsEl = document.querySelector('#search-results-desktop');
      if (desktopResultsEl) {
        new MutationObserver(function () {
          const navData = getNavData();
          if (!navData || !navData.search_active) {
            $('#search-live-status').text('');
            return;
          }
          const count = $('#search-results-desktop a[href]').length;
          $('#search-live-status').text(
            count > 0
              ? count + ' result' + (count !== 1 ? 's' : '') +
                ' found. Use arrow keys to navigate, Enter to select, Escape to close.'
              : 'No results found. Press Escape to close.'
          );
        }).observe(desktopResultsEl, { childList: true, subtree: true });
      }

});

/* === Homepage video slider accessible === */

  (function () {
    'use strict';

    var TOGGLE_SELECTOR = '[data-sound-toggle]';
    var SLIDE_SELECTOR = '.swiper-slide';
    var TOGGLE_FLAG = 'a11ySoundToggleReady';
    var SLIDER_FLAG = 'a11ySliderReady';
    var STYLE_ID = 'a11y-video-slider-styles';
    var HINT_ID = 'a11y-video-slider-hint';
    var LABEL = 'Mute video';
    var HINT_TEXT = 'Use the left and right arrow keys to move between videos. The video in the centre plays automatically.';

    function injectStyles() {
      if (document.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        TOGGLE_SELECTOR + '{cursor:pointer;}' +
        TOGGLE_SELECTOR + ':focus-visible{outline:3px solid #fff;outline-offset:3px;' +
        'box-shadow:0 0 0 5px rgba(0,0,0,.85);border-radius:4px;}' +
        '.a11y-sr-only{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;' +
        'overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;}';
      (document.head || document.documentElement).appendChild(style);
    }

    function getSwiperEl(node) {
      var el = node;
      while (el && el !== document.body) {
        if (el.swiper) return el;
        el = el.parentElement;
      }
      return null;
    }

    function findVideo(toggle) {
      var node = toggle;
      while (node && node !== document.body) {
        var video = node.querySelector('video');
        if (video) return video;
        node = node.parentElement;
      }
      return null;
    }

    function isMuted(video) {
      return !video || video.muted || video.volume === 0;
    }

    function syncState(toggle) {
      var video = toggle.__a11yVideo || findVideo(toggle);
      toggle.setAttribute('aria-pressed', isMuted(video) ? 'true' : 'false');
      if (toggle.getAttribute('aria-label') !== LABEL) toggle.setAttribute('aria-label', LABEL);
    }

    function realSlides(swiperEl) {
      return Array.prototype.filter.call(
        swiperEl.querySelectorAll(SLIDE_SELECTOR),
        function (s) { return !s.classList.contains('swiper-slide-duplicate'); }
      );
    }

    function activeToggleOf(swiperEl) {
      var active = swiperEl.querySelector('.swiper-slide-active');
      return active ? active.querySelector(TOGGLE_SELECTOR) : null;
    }

    /* ---- Roving tabindex: exactly ONE stop inside the track, so Tab can leave ---- */
    function updateRoving(swiperEl, moveFocus) {
      var wanted = activeToggleOf(swiperEl);
      var toggles = swiperEl.querySelectorAll(TOGGLE_SELECTOR);

      Array.prototype.forEach.call(toggles, function (toggle) {
        var slide = toggle.closest(SLIDE_SELECTOR);
        if (slide && slide.classList.contains('swiper-slide-duplicate')) {
          toggle.setAttribute('tabindex', '-1');
          toggle.setAttribute('aria-hidden', 'true');
          return;
        }
        toggle.removeAttribute('aria-hidden');
        toggle.setAttribute('tabindex', toggle === wanted ? '0' : '-1');
      });

      if (!wanted) return;
      var active = document.activeElement;
      var focusWasInTrack = active && active !== wanted && active.hasAttribute &&
        active.hasAttribute('data-sound-toggle') && swiperEl.contains(active);
      var focusWasLost = !active || active === document.body;

      if (moveFocus && (focusWasInTrack || focusWasLost)) {
        try { wanted.focus({ preventScroll: true }); } catch (e) { wanted.focus(); }
      }
    }

    /* ---- Only the centred slide plays ---- */
    function playActiveOnly(swiperEl) {
      Array.prototype.forEach.call(swiperEl.querySelectorAll(SLIDE_SELECTOR), function (slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (slide.classList.contains('swiper-slide-active')) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    /* ---- Bring a slide to the centre so it plays ---- */
    function centreSlide(swiperEl, slide) {
      var swiper = swiperEl.swiper;
      if (!swiper || !slide) return false;
      if (slide.classList.contains('swiper-slide-active')) {
        playActiveOnly(swiperEl);
        return false;
      }
      var real = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
      if (swiper.params.loop && !isNaN(real) && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(real);
      } else {
        swiper.slideTo(Array.prototype.indexOf.call(swiper.slides, slide));
      }
      return true;
    }

    function afterSettled(swiperEl, callback) {
      var swiper = swiperEl.swiper;
      if (!swiper || !swiper.once) { callback(); return; }
      var done = false;
      var run = function () { if (done) return; done = true; callback(); };
      swiper.once('slideChangeTransitionEnd', run);
      setTimeout(run, 600); // fallback if no transition fires
    }

    function step(swiperEl, direction) {
      var swiper = swiperEl.swiper;
      if (!swiper) return;
      var slides = realSlides(swiperEl);

      if (direction === 'next') swiper.slideNext();
      else if (direction === 'prev') swiper.slidePrev();
      else if (direction === 'first') swiper.slideToLoop ? swiper.slideToLoop(0) : swiper.slideTo(0);
      else if (direction === 'last') {
        var last = slides.length - 1;
        swiper.slideToLoop ? swiper.slideToLoop(last) : swiper.slideTo(last);
      }

      afterSettled(swiperEl, function () {
        updateRoving(swiperEl, true);   // focus follows the centred video
        playActiveOnly(swiperEl);
      });
    }

    function activate(toggle) {
      toggle.click(); // reuse the theme's own mute handler
      requestAnimationFrame(function () {
        syncState(toggle);
        // only reclaim focus if the slider dropped it, never fight the user
        if (!document.activeElement || document.activeElement === document.body) {
          try { toggle.focus({ preventScroll: true }); } catch (e) { toggle.focus(); }
        }
      });
    }

    function onKeyDown(event) {
      var toggle = event.currentTarget;
      var swiperEl = toggle.__a11ySwiperEl;
      if (event.altKey || event.ctrlKey || event.metaKey) return;

      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          activate(toggle);
          return;
        case ' ':
        case 'Spacebar':
          event.preventDefault(); // stop page scroll, act on keyup like a native button
          return;
        case 'ArrowRight':
          if (swiperEl) { event.preventDefault(); step(swiperEl, 'next'); }
          return;
        case 'ArrowLeft':
          if (swiperEl) { event.preventDefault(); step(swiperEl, 'prev'); }
          return;
        case 'Home':
          if (swiperEl) { event.preventDefault(); step(swiperEl, 'first'); }
          return;
        case 'End':
          if (swiperEl) { event.preventDefault(); step(swiperEl, 'last'); }
          return;
        default:
          if (event.keyCode === 32) event.preventDefault();
      }
    }

    function onKeyUp(event) {
      if (event.key === ' ' || event.key === 'Spacebar' || event.keyCode === 32) {
        event.preventDefault();
        activate(event.currentTarget);
      }
    }

    function enhanceToggle(toggle, swiperEl) {
      if (toggle[TOGGLE_FLAG]) return;
      toggle[TOGGLE_FLAG] = true;
      toggle.__a11ySwiperEl = swiperEl;

      if (toggle.tagName !== 'BUTTON') {
        toggle.setAttribute('role', 'button');
        toggle.addEventListener('keydown', onKeyDown);
        toggle.addEventListener('keyup', onKeyUp);
      }
      if (swiperEl) toggle.setAttribute('aria-describedby', HINT_ID);

      Array.prototype.forEach.call(toggle.querySelectorAll('svg, img, path'), function (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
      });

      var video = findVideo(toggle);
      toggle.__a11yVideo = video;
      if (video) {
        video.addEventListener('volumechange', function () { syncState(toggle); });
        if (!video.hasAttribute('title') && !video.hasAttribute('aria-label')) {
          video.setAttribute('aria-label', 'Customer review video');
        }
      }

      toggle.addEventListener('click', function () {
        requestAnimationFrame(function () { syncState(toggle); });
      });

      syncState(toggle);
    }

    function ensureHint(swiperEl) {
      if (document.getElementById(HINT_ID)) return;
      var hint = document.createElement('span');
      hint.id = HINT_ID;
      hint.className = 'a11y-sr-only';
      hint.textContent = HINT_TEXT;
      swiperEl.parentNode.insertBefore(hint, swiperEl);
    }

    function enhanceSlider(swiperEl) {
      if (swiperEl[SLIDER_FLAG]) return;
      swiperEl[SLIDER_FLAG] = true;

      ensureHint(swiperEl);

      // Swiper's own focus-scrolling fights the roving tabindex
      if (swiperEl.swiper && swiperEl.swiper.params && swiperEl.swiper.params.a11y) {
        swiperEl.swiper.params.a11y.scrollOnFocus = false;
      }

      Array.prototype.forEach.call(swiperEl.querySelectorAll(TOGGLE_SELECTOR), function (t) {
        enhanceToggle(t, swiperEl);
      });

      // A click anywhere on a slide (including the mute button) centres that video and plays it
      swiperEl.addEventListener('click', function (event) {
        var slide = event.target.closest && event.target.closest(SLIDE_SELECTOR);
        if (!slide || !swiperEl.contains(slide)) return;
        if (centreSlide(swiperEl, slide)) {
          afterSettled(swiperEl, function () {
            updateRoving(swiperEl, false);
            playActiveOnly(swiperEl);
          });
        }
      });

      // Focus (keyboard or screen reader) always centres that video and plays it
      swiperEl.addEventListener('focusin', function (event) {
        var toggle = event.target.closest && event.target.closest(TOGGLE_SELECTOR);
        if (!toggle) return;
        var slide = toggle.closest(SLIDE_SELECTOR);
        if (centreSlide(swiperEl, slide)) {
          afterSettled(swiperEl, function () {
            updateRoving(swiperEl, false);
            playActiveOnly(swiperEl);
            if (document.activeElement === toggle || !document.activeElement ||
                document.activeElement === document.body) {
              var wanted = activeToggleOf(swiperEl);
              if (wanted && wanted !== document.activeElement) {
                try { wanted.focus({ preventScroll: true }); } catch (e) { wanted.focus(); }
              }
            }
          });
        }
      });

      var swiper = swiperEl.swiper;
      if (swiper && swiper.on) {
        swiper.on('slideChangeTransitionEnd', function () { updateRoving(swiperEl, false); });
        swiper.on('slidesUpdated', function () { updateRoving(swiperEl, false); });
        swiper.on('loopFix', function () { updateRoving(swiperEl, false); });
      }

      updateRoving(swiperEl, false);
    }

    function scan(root) {
      var seen = [];
      Array.prototype.forEach.call((root || document).querySelectorAll(TOGGLE_SELECTOR), function (toggle) {
        var swiperEl = getSwiperEl(toggle);
        if (swiperEl) {
          if (seen.indexOf(swiperEl) === -1) { seen.push(swiperEl); enhanceSlider(swiperEl); }
        } else {
          enhanceToggle(toggle, null); // standalone video, no carousel
          if (!toggle.hasAttribute('tabindex')) toggle.setAttribute('tabindex', '0');
        }
      });
    }

    function init() {
      injectStyles();
      scan(document);

      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(TOGGLE_SELECTOR)) scan(node.parentNode || document);
            else if (node.querySelector && node.querySelector(TOGGLE_SELECTOR)) scan(node);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });

      document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      setTimeout(init, 0); // let Swiper finish initialising
    }
  })();


/* Angelus Direct — Accessible multi-select colour swatches (Easify / TPO Product Options) The selection limit is resolved AT RUNTIME per product + variant. Nothing is hardcoded.  */

  //   (function () {
  //   'use strict';
  //   var CONFIG = { enforce:'block', keyboardNav:true, syncVisibleCopy:true, unlimitedAt:999, noun:'color' };
  //   var SEL = {
  //     option:'.tpo_option-container', grid:'.tpo_option-type-image-swatches-wrapper', input:'.tpo_color-swatches-input',
  //     imageWrap:'.tpo_image-wrapper', labelBox:'.tpo_option-label-container', valueLabel:'.tpo_option_type_label_wrapper',
  //     help:'.tpo_option-help-text', err:'.tpo_error-message', limitEl:'.tpo_quantity_selector_total-limit',
  //     counterWrap:'.tpo_quantity_selector_total-content', checkedCls:'tpo_is_checked_swatches'
  //   };
  //   // The widget commits a swatch on pointerup, so every phase of the gesture must be intercepted.
  //   var GESTURE = ['pointerdown','pointerup','mousedown','mouseup','click','touchstart','touchend'];
  //   var WORDS = {one:1,two:2,three:3,four:4,five:5,six:6,seven:7,eight:8,nine:9,ten:10,eleven:11,twelve:12,fifteen:15,eighteen:18,twenty:20};
  //   var groups = [], uid = 0;

  //   function num(v){
  //     if (v === null || v === undefined) return null;
  //     var s = String(v), m = s.match(/\d{1,4}/);
  //     if (m) return parseInt(m[0],10);
  //     var w = s.toLowerCase().match(new RegExp('\\b(' + Object.keys(WORDS).join('|') + ')\\b'));
  //     return w ? WORDS[w[1]] : null;
  //   }
  //   function txt(el){ return el ? String(el.textContent||'').replace(/\s+/g,' ').trim() : ''; }
  //   function pl(n){ return n === 1 ? CONFIG.noun : CONFIG.noun + 's'; }
  //   function isChecked(input){ var lab = input.closest('label'); return !!(input.checked || (lab && lab.classList.contains(SEL.checkedCls))); }

  //   /* ---------- 1. DYNAMIC LIMIT RESOLUTION ---------- */
  //   function allConfigOptions(){
  //     var cfg = window.TPOConfigs || {}, out = [];
  //     [cfg.product_options_easify, cfg.product_options_tpo].forEach(function(bucket){
  //       (Array.isArray(bucket)?bucket:[]).forEach(function(entry){
  //         var os = entry && entry.option_set;
  //         if (os && Array.isArray(os.options)) out = out.concat(os.options);
  //       });
  //     });
  //     return out;
  //   }
  //   function configCandidates(uuid, ident){
  //     var list = allConfigOptions();
  //     function pick(fn){ return list.filter(fn); }
  //     // Option UUIDs are cloned across option sets, so the rendered option_identifier
  //     // (the swatch input id prefix) is what actually identifies this instance.
  //     var byBoth = pick(function(o){ return o && o.id === uuid && ident && o.option_identifier === ident; });
  //     if (byBoth.length) return byBoth;
  //     var byIdent = pick(function(o){ return o && ident && o.option_identifier === ident; });
  //     if (byIdent.length) return byIdent;
  //     var byTitle = pick(function(o){ return o && ident && o.title === ident; });
  //     if (byTitle.length) return byTitle;
  //     return pick(function(o){ return o && o.id === uuid; });
  //   }
  //   function candidateLimits(cands){
  //     var vals=[], mins=[], titles=[];
  //     cands.forEach(function(o){
  //       var m = null;
  //       if (o.max_value != null && +o.max_value > 0) m = +o.max_value;
  //       try {
  //         var qs = JSON.parse(o.quantity_selector || '{}');
  //         var lt = qs && qs.configs ? +qs.configs.limitTotalSelected : 0;  // 0 = not in use
  //         if (lt > 0 && (m === null || lt < m)) m = lt;
  //       } catch(e){}
  //       if (m !== null && vals.indexOf(m) === -1) vals.push(m);
  //       if (o.min_value != null && mins.indexOf(+o.min_value) === -1) mins.push(+o.min_value);
  //       if (o.title && titles.indexOf(o.title) === -1) titles.push(o.title);
  //     });
  //     return { max: vals.length === 1 ? vals[0] : null, all: vals, min: mins.length === 1 ? mins[0] : null, title: titles[0] || null };
  //   }
  //   function renderedIdent(optionEl){
  //     var first = optionEl.querySelector(SEL.input);
  //     return first ? String(first.id || '').replace(/-\d+$/,'') : null;
  //   }
  //   function domLimit(optionEl, ident){
  //     var d;
  //     if ((d = num(txt(optionEl.querySelector(SEL.limitEl)))) > 0) return { max:d, source:'dom:total-limit' };
  //     if ((d = num(ident)) > 0) return { max:d, source:'dom:option-identifier' };
  //     if ((d = num(txt(optionEl.querySelector(SEL.labelBox)))) > 0) return { max:d, source:'dom:label' };
  //     if ((d = num(txt(optionEl.querySelector(SEL.help)))) > 0) return { max:d, source:'dom:help-text' };
  //     return { max:null, source:null };
  //   }
  //   function resolveLimit(optionEl){
  //     var uuid  = String(optionEl.getAttribute('id')||'').split(',')[1] || null;
  //     var ident = renderedIdent(optionEl);
  //     var cands = configCandidates(uuid, ident);
  //     var cfg   = candidateLimits(cands);
  //     var dom   = domLimit(optionEl, ident);
  //     var max = null, source = 'none', mismatch = false;
  //     if (cfg.max !== null) {
  //       max = cfg.max; source = 'config:max_value';
  //       if (dom.max !== null && dom.max !== cfg.max) mismatch = true;   // merchant copy disagrees with app rule
  //     } else if (dom.max !== null) {
  //       max = dom.max; source = dom.source;   // config ambiguous -> trust what is rendered
  //     }
  //     var unlimited = (max === null || max >= CONFIG.unlimitedAt);
  //     return {
  //       max: unlimited ? null : max, min: cfg.min, unlimited: unlimited, source: source,
  //       title: cfg.title || ident, ident: ident, candidates: cands.length,
  //       configMaxes: cfg.all, domMax: dom.max, mismatch: mismatch,
  //       label: txt(optionEl.querySelector(SEL.labelBox)).replace(/\*\s*$/,'').trim()
  //     };
  //   }

  //   /* ---------- 2. WORDING (always derived from the resolved limit) ---------- */
  //   function instructionText(L,total){
  //     if (L.unlimited) return 'Choose your ' + pl(2) + '. ' + total + ' ' + pl(total) + ' available.';
  //     return 'Choose your ' + L.max + ' ' + pl(L.max) + '. Select exactly ' + L.max + ' of ' + total + ' available ' + pl(total) + '.';
  //   }
  //   function statusText(L,n){
  //     if (L.unlimited) return n + ' ' + pl(n) + ' selected.';
  //     return n + ' of ' + L.max + ' ' + pl(L.max) + ' selected. ' + (n >= L.max ? 'Selection complete.' : (L.max-n) + ' remaining.');
  //   }
  //   function limitText(L,name){
  //     return 'Limit reached. You can choose only ' + L.max + ' ' + pl(L.max) + '. Deselect one of your ' + L.max + ' selected ' + pl(L.max) + (name ? ' before choosing ' + name + '.' : '.');
  //   }

  //   /* ---------- 3. CSS: keep the hidden checkbox focusable ---------- */
  //   function injectCSS(){
  //     if (document.getElementById('ng-a11y-swatch-css')) return;
  //     var s = document.createElement('style'); s.id = 'ng-a11y-swatch-css';
  //     s.textContent = [
  //       '.ng-a11y-sr{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;border:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;}',
  //       '.tpo_color-swatches-input.ng-a11y-focusable{visibility:visible!important;opacity:0!important;width:1px!important;height:1px!important;pointer-events:none!important;}',
  //       'label.ng-a11y-focus{outline:3px solid #005fcc!important;outline-offset:3px!important;}',
  //       'label.ng-a11y-at-limit .tpo_image-wrapper{opacity:.55;}'
  //     ].join('\n');
  //     (document.head||document.documentElement).appendChild(s);
  //   }

  //   /* ---------- 4. helpers ---------- */
  //   function srNode(tag,cls){ var n=document.createElement(tag); n.className=cls; return n; }
  //   function swatchName(input){
  //     var lab=input.closest('label'), wrap=lab&&lab.parentElement;
  //     var vis = wrap ? txt(wrap.querySelector(SEL.valueLabel)) : '';
  //     return (vis || String(input.value||'') || 'color').replace(/\s+/g,' ').trim();
  //   }
  //   function countChecked(g){ var n=0; g.inputs.forEach(function(i){ if(isChecked(i)) n++; }); return n; }
  //   function say(region,msg){ if(!region) return; region.textContent=''; window.setTimeout(function(){ region.textContent=msg; },60); }
  //   function gridCols(grid){ var m=String(grid.className||'').match(/tpo-grid-(\d+)/); return m?parseInt(m[1],10):4; }
  //   function groupFor(node){ for(var i=0;i<groups.length;i++) if(groups[i].grid.contains(node)) return groups[i]; return null; }
  //   function forwardGesture(el){
  //     var r = el.getBoundingClientRect();
  //     var down = {bubbles:true,cancelable:true,composed:true,view:window,button:0,buttons:1,clientX:r.left+r.width/2,clientY:r.top+r.height/2,pointerId:1,pointerType:'mouse',isPrimary:true};
  //     var up = Object.assign({},down,{buttons:0});
  //     try{ el.dispatchEvent(new PointerEvent('pointerdown',down)); }catch(e){}
  //     el.dispatchEvent(new MouseEvent('mousedown',down));
  //     try{ el.dispatchEvent(new PointerEvent('pointerup',up)); }catch(e){}
  //     el.dispatchEvent(new MouseEvent('mouseup',up));
  //     el.dispatchEvent(new MouseEvent('click',up));
  //   }

  //   /* ---------- 5. group setup ---------- */
  //   function initGroup(optionEl){
  //     var grid = optionEl.querySelector(SEL.grid);
  //     var inputs = [].slice.call(optionEl.querySelectorAll(SEL.input));
  //     if (!grid || !inputs.length) return null;
  //     var gid = optionEl.getAttribute('data-ng-a11y-id');
  //     if (!gid) { gid = 'ng-sw-' + (++uid); optionEl.setAttribute('data-ng-a11y-id', gid); }
  //     var L = resolveLimit(optionEl);
  //     var labelBox = optionEl.querySelector(SEL.labelBox);
  //     if (labelBox && !labelBox.id) labelBox.id = gid + '-label';
  //     var instr = document.getElementById(gid+'-instr');
  //     if (!instr){ instr=srNode('p','ng-a11y-sr'); instr.id=gid+'-instr'; grid.parentNode.insertBefore(instr,grid); }
  //     var live = document.getElementById(gid+'-live');
  //     if (!live){ live=srNode('div','ng-a11y-sr'); live.id=gid+'-live'; live.setAttribute('role','status'); live.setAttribute('aria-live','polite'); live.setAttribute('aria-atomic','true'); grid.parentNode.appendChild(live); }
  //     var alertR = document.getElementById(gid+'-alert');
  //     if (!alertR){ alertR=srNode('div','ng-a11y-sr'); alertR.id=gid+'-alert'; alertR.setAttribute('role','alert'); alertR.setAttribute('aria-live','assertive'); alertR.setAttribute('aria-atomic','true'); grid.parentNode.appendChild(alertR); }
  //     grid.setAttribute('role','group');
  //     if (labelBox) grid.setAttribute('aria-labelledby', labelBox.id);
  //     grid.setAttribute('aria-describedby', instr.id);
  //     var g = {el:optionEl,gid:gid,grid:grid,inputs:inputs,L:L,live:live,alert:alertR,instr:instr,cols:gridCols(grid)};
  //     inputs.forEach(function(input,i){
  //       input.classList.add('ng-a11y-focusable');
  //       input.setAttribute('aria-describedby', instr.id);
  //       input.setAttribute('data-ng-index', String(i));
  //       input.setAttribute('tabindex', CONFIG.keyboardNav ? (i===0?'0':'-1') : '0');
  //     });
  //     refreshGroup(g,{silent:true}); bindGroup(g); observeGroup(g);
  //     return g;
  //   }

  //   function refreshGroup(g,opts){
  //     opts = opts || {};
  //     var L=g.L, total=g.inputs.length, n=countChecked(g);
  //     // safety net: if a pick slipped past the blocker, undo it
  //     if (!L.unlimited && n > L.max && CONFIG.enforce==='block' && !g.reverting && opts.changedInput && opts.nowChecked) { revert(g,opts.changedInput); return; }
  //     var atLimit = !L.unlimited && n >= L.max;
  //     g.inputs.forEach(function(input,i){
  //       var checked = isChecked(input);
  //       input.setAttribute('aria-label', swatchName(input) + ', ' + (i+1) + ' of ' + total);
  //       if (atLimit && !checked) input.setAttribute('aria-disabled','true'); else input.removeAttribute('aria-disabled');
  //       var lab = input.closest('label');
  //       if (lab) lab.classList[atLimit && !checked ? 'add':'remove']('ng-a11y-at-limit');
  //     });
  //     var cw = g.el.querySelector(SEL.counterWrap);
  //     if (cw) cw.setAttribute('aria-hidden','true');   // decorative "n/N"; announced properly instead
  //     g.instr.textContent = instructionText(L,total) + ' ' + statusText(L,n);
  //     if (!opts.silent){
  //       var parts=[];
  //       if (opts.changedName) parts.push(opts.changedName + (opts.nowChecked?' selected.':' removed.'));
  //       parts.push(statusText(L,n));
  //       say(g.live, parts.join(' '));
  //     }
  //     g.lastCount = n;
  //   }

  //   function revert(g,input){
  //     g.reverting = true;
  //     var lab = input.closest('label');
  //     if (lab) forwardGesture(lab.querySelector(SEL.imageWrap) || lab);
  //     say(g.alert, limitText(g.L, swatchName(input)));
  //     window.setTimeout(function(){ g.reverting=false; refreshGroup(g,{silent:true}); },400);
  //   }
  //   function activate(g,input){
  //     if (!g.L.unlimited && !isChecked(input) && countChecked(g) >= g.L.max){ say(g.alert, limitText(g.L, swatchName(input))); return; }
  //     var lab = input.closest('label');
  //     forwardGesture(lab.querySelector(SEL.imageWrap) || lab);
  //   }

  //   function bindGroup(g){
  //     if (g.grid.__ngBound) return;
  //     g.grid.__ngBound = true;
  //     g.grid.addEventListener('change', function(e){
  //       var input = e.target && e.target.closest ? e.target.closest(SEL.input) : null;
  //       if (input) refreshGroup(g,{changedName:swatchName(input),nowChecked:input.checked,changedInput:input});
  //     });
  //     g.grid.addEventListener('focusin', function(e){
  //       var input = e.target && e.target.closest ? e.target.closest(SEL.input) : null;
  //       if (!input) return;
  //       var lab = input.closest('label');
  //       if (lab) lab.classList.add('ng-a11y-focus');
  //       if (CONFIG.keyboardNav) g.inputs.forEach(function(i){ i.setAttribute('tabindex', i===input?'0':'-1'); });
  //     });
  //     g.grid.addEventListener('focusout', function(e){
  //       var input = e.target && e.target.closest ? e.target.closest(SEL.input) : null;
  //       var lab = input && input.closest('label');
  //       if (lab) lab.classList.remove('ng-a11y-focus');
  //     });
  //     g.grid.addEventListener('keydown', function(e){
  //       var input = e.target && e.target.closest ? e.target.closest(SEL.input) : null;
  //       if (!input) return;
  //       var idx = g.inputs.indexOf(input), next = null;
  //       if (e.key===' '||e.key==='Spacebar'||e.key==='Enter'){ e.preventDefault(); activate(g,input); return; }
  //       if (!CONFIG.keyboardNav) return;
  //       if (e.key==='ArrowRight') next=idx+1;
  //       else if (e.key==='ArrowLeft') next=idx-1;
  //       else if (e.key==='ArrowDown') next=idx+g.cols;
  //       else if (e.key==='ArrowUp') next=idx-g.cols;
  //       else if (e.key==='Home') next=0;
  //       else if (e.key==='End') next=g.inputs.length-1;
  //       else return;
  //       e.preventDefault();
  //       if (next>=0 && next<g.inputs.length) g.inputs[next].focus();
  //     });
  //   }

  //   function observeGroup(g){
  //     if (g.el.__ngObs) return;
  //     var mo = new MutationObserver(function(muts){
  //       var changed=null, sawChild=false;
  //       muts.forEach(function(m){
  //         if (m.type==='attributes' && m.attributeName==='class' && m.target.tagName==='LABEL'){
  //           var was = /tpo_is_checked_swatches/.test(m.oldValue||'');
  //           var is = m.target.classList.contains(SEL.checkedCls);
  //           if (was !== is) changed = {el:m.target, nowChecked:is};
  //         }
  //         if (m.type==='childList') sawChild = true;
  //       });
  //       if (changed){
  //         var input = changed.el.querySelector(SEL.input);
  //         refreshGroup(g,{changedName: input?swatchName(input):null, nowChecked:changed.nowChecked, changedInput:input});
  //       }
  //       if (sawChild) mirrorError(g);
  //     });
  //     mo.observe(g.el,{subtree:true,childList:true,attributes:true,attributeFilter:['class'],attributeOldValue:true});
  //     g.el.__ngObs = mo;
  //   }

  //   // The app renders "Please select at maximum N options" outside any live region.
  //   function mirrorError(g){
  //     var err = g.el.querySelector(SEL.err);
  //     if (!err){ g.lastErr=null; return; }
  //     var raw = txt(err);
  //     if (!raw || raw === g.lastErr) return;
  //     g.lastErr = raw;
  //     var msg = raw;
  //     if (!g.L.unlimited){
  //       if (/maximum|at most|only/i.test(raw)) msg = 'You can choose only ' + g.L.max + ' ' + pl(g.L.max) + '. ' + statusText(g.L,countChecked(g));
  //       else if (/minimum|required|at least/i.test(raw)) msg = 'Please choose ' + g.L.max + ' ' + pl(g.L.max) + ' to continue. ' + statusText(g.L,countChecked(g));
  //       if (CONFIG.syncVisibleCopy && msg !== raw){ err.textContent = msg; g.lastErr = msg; }
  //     }
  //     err.setAttribute('role','alert');
  //     say(g.alert,msg);
  //   }

  //   /* ---------- 6. global over-limit blocker ---------- */
  //   function installBlocker(){
  //     if (window.__ngA11yBlocker) return;
  //     window.__ngA11yBlocker = true;
  //     GESTURE.forEach(function(type){
  //       window.addEventListener(type, function(e){
  //         if (CONFIG.enforce !== 'block') return;
  //         var t = e.target;
  //         if (!t || !t.closest) return;
  //         var lab = t.closest('label');
  //         if (!lab) return;
  //         var input = lab.querySelector(SEL.input);
  //         if (!input) return;
  //         var g = groupFor(lab);
  //         if (!g || g.L.unlimited || g.reverting) return;
  //         if (isChecked(input)) return;                    // deselecting is always allowed
  //         if (countChecked(g) < g.L.max) return;           // still under the limit
  //         e.preventDefault(); e.stopPropagation();
  //         if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  //         if (type==='pointerup' || type==='touchend'){
  //           var now = Date.now();
  //           if (!g.lastBlock || now-g.lastBlock > 400){ g.lastBlock=now; say(g.alert, limitText(g.L, swatchName(input))); }
  //         }
  //       }, true);
  //     });
  //   }

  //   /* ---------- 7. scan + stay in sync with variant changes ---------- */
  //   function scan(){
  //     injectCSS();
  //     var found=[];
  //     [].slice.call(document.querySelectorAll(SEL.option)).forEach(function(optionEl){
  //       if (!optionEl.querySelector(SEL.input)) return;
  //       var g = initGroup(optionEl);
  //       if (g) found.push(g);
  //     });
  //     groups = found; installBlocker();
  //     return groups;
  //   }
  //   var t;
  //   function schedule(){ clearTimeout(t); t = window.setTimeout(scan,250); }
  //   function boot(){
  //     scan();
  //     var root = document.querySelector('.easify-product-options') || document.body;
  //     new MutationObserver(function(muts){
  //       for (var i=0;i<muts.length;i++) if (muts[i].type==='childList' && (muts[i].addedNodes.length||muts[i].removedNodes.length)){ schedule(); return; }
  //     }).observe(root,{childList:true,subtree:true});
  //     document.addEventListener('change', function(e){ if (e.target && e.target.name==='id') schedule(); }, true);
  //     window.addEventListener('variant:changed', schedule);
  //     window.addEventListener('pageshow', schedule);
  //   }

  //   window.NgSwatchA11y = {
  //     refresh: scan, config: CONFIG,
  //     debug: function(){
  //       return groups.map(function(g){
  //         return {gid:g.gid,label:g.L.label,limit:g.L.max,unlimited:g.L.unlimited,source:g.L.source,ident:g.L.ident,
  //                 candidates:g.L.candidates,configMaxes:g.L.configMaxes,domMax:g.L.domMax,mismatch:g.L.mismatch,
  //                 swatches:g.inputs.length,selected:countChecked(g),instructions:g.instr.textContent};
  //       });
  //     }
  //   };
  //   if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  // })();



/*! a11y.js — module: "Frequently Bought Together" (MBC Bundles) — WCAG patch
 *  ------------------------------------------------------------------------
 *  1. Late DOM injection: announced via a visually-hidden polite live region
 *     created up-front and parked next to the section.
 *  2. Reading / tab order: asserted to sit after the product Add-to-Cart block.
 *  3. Horizontal scroll on keyboard focus: clipped track is scroll-locked and
 *     the carousel is driven to the slide holding focus.
 *  4. Scroll-region semantics + labelled pager with live aria-disabled state.
 *  5. Container keyboard-scrollable itself: tabindex="0" + Arrow/Home/End.
 *  6. Re-asserts the checkbox CSS the app's late <style> was clobbering.
 *  WCAG: 1.3.1, 1.3.2, 2.1.1, 2.4.3, 2.4.7, 4.1.2, 4.1.3   Deps: jQuery 3.x
 */
  (function ($) {
    'use strict';
    if (!$) { return; }
    if (window.__a11yFbtLoaded) { return; }        // singleton: survive double include
    window.__a11yFbtLoaded = true;

    var CFG = {
      widget:   '#mbcBundleItemsWidget',
      track:    '.keen-slider',
      slide:    '.keen-slider__slide',
      bundle:   '.mbc-bundle',
      title:    '.mbc-bundles-list__title',
      itemsRow: '.mbc-bundle__items',
      item:     '.mbc-bundle__item',
      prevBtn:  '.mbc-bundle-arrow.prev',
      nextBtn:  '.mbc-bundle-arrow.next',
      disCls:   'arrow--disabled',
      label:    'Frequently bought together',
      pad:      24,
      styleId:  'a11y-fbt-region-css',
      liveId:   'a11y-fbt-live',
      trackId:  'a11y-fbt-track'
    };

    function reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function behavior() { return reduced() ? 'auto' : 'smooth'; }

    /* Always resolve live: the app re-renders this subtree on every variant
      change, so nothing may be cached in a closure. */
    function $widget()  { return $(CFG.widget).first(); }
    function $track()   { return $widget().find(CFG.track).first(); }
    function $slides()  { var $t = $track(); return $t.length ? $t.children(CFG.slide) : $(); }
    function sectionName() {
      return $.trim($widget().find(CFG.title).first().text()) || CFG.label;
    }

    /* ---- 1. CSS: re-appended each pass so it outranks the app's late <style> */
    function injectCss() {
      var $s = $('#' + CFG.styleId);
      if (!$s.length) {
        $s = $('<style/>', { id: CFG.styleId }).text([
          /* shared a11y.js visually-hidden helper */
          '.a11y-vh{position:absolute !important;width:1px;height:1px;margin:-1px;padding:0;',
          'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;}',

          /* 2.1.1 — keep the real checkbox focusable (ID-qualified so the app
            stylesheet cannot out-cascade it back to display:none) */
          '#mbcBundleItemsWidget .mbc-checkbox__label{position:relative;display:inline-flex;',
          'align-items:center;justify-content:center;min-width:24px;min-height:24px;cursor:pointer;}',
          '#mbcBundleItemsWidget .mbc-checkbox__label .mbc-checkbox__input{display:block !important;',
          'position:absolute !important;inset:0;width:100%;height:100%;margin:0;opacity:0;cursor:pointer;}',
          '#mbcBundleItemsWidget .mbc-checkbox__input:focus-visible + .mbc-checkbox__fake{',
          'outline:3px solid #1f1f1f;outline-offset:3px;}',

          /* 2.4.7 — the scroll containers are focusable, so they need a ring */
          '[data-a11y-fbt-track]:focus-visible,[data-a11y-fbt-scroller]:focus-visible{',
          'outline:3px solid #1f1f1f;outline-offset:3px;}',

          /* genuine overflow rows: padded, smooth, contained scrolling */
          '[data-a11y-fbt-scroller]{scroll-behavior:smooth;overscroll-behavior-x:contain;}',
          '[data-a11y-fbt-scroller] > ' + CFG.item + '{scroll-margin-inline:' + CFG.pad + 'px;}',

          /* clipped transform-driven track: never animate a native scroll */
          '[data-a11y-fbt-track][data-a11y-fbt-clipped]{scroll-behavior:auto;}',

          '@media (prefers-reduced-motion: reduce){',
          '[data-a11y-fbt-scroller]{scroll-behavior:auto;}}'
        ].join(''));
      }
      $s.appendTo('head');
    }

    /* ---- 2. Live region — exists BEFORE the section renders (4.1.3) -------- */
    function $live() {
      var $l = $('#' + CFG.liveId);
      if (!$l.length) {
        $l = $('<div/>', {
          id: CFG.liveId, 'class': 'a11y-vh',
          role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true'
        }).appendTo('body');
      }
      /* Park it immediately before the section as soon as that exists, so the
        announcement also sits in the right place in the reading order. Done
        once, and only while empty, so no SR re-reads on relocation. */
      if ($l.data('a11yFbtParked') !== true) {
        var $w = $widget();
        if ($w.length) {
          var $blk = $w.closest('.shopify-app-block');
          var ref  = ($blk.length ? $blk : $w)[0];
          if ($l[0].nextElementSibling !== ref) { $l.text('').insertBefore(ref); }
          $l.data('a11yFbtParked', true);
        }
      }
      return $l;
    }

    function announce(msg) {
      var $l = $live();
      if ($l.text() === msg) { $l.text(''); }        // force a re-read
      window.setTimeout(function () { $l.text(msg); }, 120);
    }

    /* ---- 3. Reading / tab order (1.3.2, 2.4.3) ---------------------------- */
    function ensureReadingOrder() {
      var $w = $widget();
      var $blk = $w.closest('.shopify-app-block');
      var $node = $blk.length ? $blk : $w;
      if (!$node.length || $node.attr('data-a11y-fbt-order')) { return; }

      var atc = document.querySelector('button[name="add"]') ||
                document.querySelector('form[action*="/cart/add"] [type="submit"]');
      if (!atc) { return; }

      var pos = atc.compareDocumentPosition($node[0]);
      if ((pos & Node.DOCUMENT_POSITION_FOLLOWING) && !(pos & Node.DOCUMENT_POSITION_CONTAINED_BY)) {
        $node.attr('data-a11y-fbt-order', 'ok');                   // already logical
        return;
      }
      var $host = $(atc).closest('.addtocart, .product-form, form').first();
      if ($host.length) { $node.insertAfter($host).attr('data-a11y-fbt-order', 'moved'); }
    }

    /* ---- 4. Region / carousel semantics (1.3.1, 4.1.2) -------------------- */
    function decorate() {
      var $w = $widget(), $t = $track(), $sl = $slides(), name = sectionName();

      $w.attr({ role: 'region', 'aria-label': name });

      if ($t.length) {
        if (!$t.attr('id')) { $t.attr('id', CFG.trackId); }
        $t.attr({
          'data-a11y-fbt-track': 'true',
          role: 'group',
          'aria-roledescription': 'carousel',
          'aria-label': name + ' bundles',
          'aria-orientation': 'horizontal',
          tabindex: '0'
        });

        var cs = window.getComputedStyle($t[0]);
        if (/(hidden|clip)/.test(cs.overflowX) && $t[0].scrollWidth > $t[0].clientWidth + 2) {
          $t.attr('data-a11y-fbt-clipped', 'true');
          lockScroll($t);
        } else {
          $t.removeAttr('data-a11y-fbt-clipped');
        }

        /* Slides stay exposed to AT — never aria-hidden / inert, or the
          off-screen bundle becomes unreachable. Focus reveals it instead. */
        $sl.each(function (i) {
          $(this).attr({
            role: 'group',
            'aria-roledescription': 'slide',
            'aria-label': 'Bundle ' + (i + 1) + ' of ' + $sl.length
          }).removeAttr('aria-hidden');
        });

        $w.find(CFG.prevBtn).attr({ 'aria-label': 'Previous bundle', 'aria-controls': $t.attr('id') });
        $w.find(CFG.nextBtn).attr({ 'aria-label': 'Next bundle',     'aria-controls': $t.attr('id') });
        syncArrows();
      }

      /* item rows that scroll on their own (narrow viewports) */
      $w.find(CFG.itemsRow).each(function () {
        var el = this, s = window.getComputedStyle(el);
        if (/(auto|scroll)/.test(s.overflowX) && el.scrollWidth > el.clientWidth + 2) {
          $(el).attr({
            'data-a11y-fbt-scroller': 'true',
            role: 'region',
            'aria-label': 'Bundle products, scrollable',
            'aria-orientation': 'horizontal',
            tabindex: '0'
          });
        } else {
          $(el).removeAttr('data-a11y-fbt-scroller role aria-orientation tabindex');
        }
      });
    }

    function syncArrows() {
      $widget().find(CFG.prevBtn + ',' + CFG.nextBtn).each(function () {
        $(this).attr('aria-disabled', $(this).hasClass(CFG.disCls) ? 'true' : 'false');
      });
    }

    /* ---- 5. Horizontal scrolling & focus (2.1.1, 2.4.3, 2.4.7) ------------ */

    /* keen-slider moves slides with transforms, so the clipped track must never
      hold a scroll offset. Without this the browser scrolls it on focus and the
      focused product ends up half-clipped / the row looks broken. */
    function lockScroll($t) {
      if (!$t.length || $t.data('a11yFbtLocked')) { return; }
      $t.data('a11yFbtLocked', true);
      var el = $t[0];
      var reset = function () { if (el.scrollLeft !== 0) { el.scrollLeft = 0; } };
      el.addEventListener('scroll', reset, { passive: true });
      $t.on('a11y:resync', reset);
      reset();
    }
    function resync() {
      var $t = $track();
      if ($t.length) { $t.trigger('a11y:resync'); }
    }

    function scrollerFor(el, boundary) {
      var node = el;
      while (node && node !== boundary && node !== document.body) {
        if (node.nodeType === 1) {
          if (node.hasAttribute('data-a11y-fbt-scroller')) { return node; }
          var s = window.getComputedStyle(node);
          if (/(auto|scroll)/.test(s.overflowX) && node.scrollWidth > node.clientWidth + 2) { return node; }
        }
        node = node.parentNode;
      }
      return null;
    }

    /* Manual scroll maths, so a target clipped at the START of the row is
      revealed just as reliably as one clipped at the end — and the page is
      never yanked vertically the way scrollIntoView() ancestors do. */
    function revealX(box, target) {
      var b = box.getBoundingClientRect(), t = target.getBoundingClientRect();
      var start = (t.left - b.left) + box.scrollLeft;
      var end   = start + t.width;
      var max   = Math.max(0, box.scrollWidth - box.clientWidth);
      var to    = null;

      if (start - CFG.pad < box.scrollLeft) { to = start - CFG.pad; }
      else if (end + CFG.pad > box.scrollLeft + box.clientWidth) { to = end + CFG.pad - box.clientWidth; }
      if (to === null) { return false; }

      to = Math.max(0, Math.min(max, to));
      if (typeof box.scrollTo === 'function') {
        box.scrollTo({ left: to, top: box.scrollTop, behavior: behavior() });
      } else {
        box.scrollLeft = to;
      }
      return true;
    }

    /* Which slide is parked in the track viewport (transform-aware). */
    function activeIndex() {
      var $t = $track(), $sl = $slides();
      if (!$t.length || !$sl.length) { return 0; }
      var left = $t[0].getBoundingClientRect().left, best = 0, bestD = Infinity;
      $sl.each(function (i) {
        var d = Math.abs(this.getBoundingClientRect().left - left);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    /* Drive the carousel with its own controls, then clear any stray scroll. */
    function gotoSlide(want) {
      var $w = $widget(), $sl = $slides();
      if (!$sl.length) { return want; }
      want = Math.max(0, Math.min($sl.length - 1, want));
      for (var guard = 0; guard < 12; guard++) {
        var cur = activeIndex();
        if (cur === want) { break; }
        var $btn = (cur < want ? $w.find(CFG.nextBtn) : $w.find(CFG.prevBtn)).first();
        if (!$btn.length || $btn.hasClass(CFG.disCls)) { break; }
        $btn.trigger('click');
      }
      syncArrows();
      resync();
      return want;
    }

    function announceSlide(i) {
      var $sl = $slides();
      if (!$sl.length) { return; }
      announce($sl.eq(i).attr('aria-label') || ('Bundle ' + (i + 1)));
    }

    /* NOTE: bound on the widget, not delegated from document — something in the
      theme stops focusin propagation above this subtree. Re-bound per element
      because the app replaces the node on re-render. */
    function wire() {
      var $w = $widget();
      if (!$w.length || $w.data('a11yFbtBound')) { return; }
      $w.data('a11yFbtBound', true);

      /* focus-follows-scroll */
      $w.on('focusin.a11yFbt', function (e) {
        var el = e.target;

        var box = scrollerFor(el, $widget()[0]);
        if (box) { revealX(box, $(el).closest(CFG.item)[0] || el); }

        var $sl = $slides();
        if (!$sl.length) { return; }
        var $slide = $(el).closest(CFG.slide);
        if (!$slide.length) { return; }

        var want = $sl.index($slide[0]);
        if (want > -1 && want !== activeIndex()) {
          gotoSlide(want);
          announceSlide(want);
        }
        resync();
        window.requestAnimationFrame(resync);
      });

      /* the containers scroll by keyboard in their own right */
      $w.on('keydown.a11yFbt', '[data-a11y-fbt-track],[data-a11y-fbt-scroller]', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) { return; }
        var box = this;
        var isTrack = box.hasAttribute('data-a11y-fbt-track');
        var step = Math.max(120, Math.round(box.clientWidth * 0.9));
        var last = Math.max(0, $slides().length - 1);
        var cur  = isTrack ? activeIndex() : 0;
        var want = null;
        var done = true;

        switch (e.key) {
          case 'ArrowRight':
            if (isTrack) { want = cur + 1; }
            else { box.scrollTo({ left: box.scrollLeft + step, behavior: behavior() }); }
            break;
          case 'ArrowLeft':
            if (isTrack) { want = cur - 1; }
            else { box.scrollTo({ left: box.scrollLeft - step, behavior: behavior() }); }
            break;
          case 'Home':
            if (isTrack) { want = 0; }
            else { box.scrollTo({ left: 0, behavior: behavior() }); }
            break;
          case 'End':
            if (isTrack) { want = last; }
            else { box.scrollTo({ left: box.scrollWidth, behavior: behavior() }); }
            break;
          default: done = false;
        }
        if (!done) { return; }
        e.preventDefault();
        /* announce the requested slide: activeIndex() is unreliable while the
          slider is still animating its transform */
        if (want !== null) { announceSlide(gotoSlide(want)); }
      });

      /* keep the exposed pager state honest when the app drives the slider */
      $w.on('click.a11yFbt', CFG.prevBtn + ',' + CFG.nextBtn, function () {
        window.setTimeout(function () { syncArrows(); resync(); }, 60);
        window.setTimeout(function () { announceSlide(activeIndex()); }, 450);
      });

      $(window).on('resize.a11yFbt orientationchange.a11yFbt', function () {
        window.setTimeout(resync, 100);
      });
    }

    /* ---- 6. Idempotent enhancement pass ---------------------------------- */
    function enhance() {
      var $w = $widget();
      if (!$w.length || !$w.find(CFG.bundle).length) { return false; }

      injectCss();
      $live();
      ensureReadingOrder();
      decorate();
      wire();

      var n = $w.find(CFG.bundle).length;
      if ($w.data('a11yFbtCount') !== n) {           // announce once per change
        $w.data('a11yFbtCount', n);
        announce(sectionName() + ' section loaded, ' + n + ' bundle' + (n === 1 ? '' : 's') +
                ' available after the Add to Cart button.');
      }
      $w.attr('data-a11y-fbt', 'ready');
      return true;
    }

    /* ---- 7. Catch the late injection and every re-render ----------------- */
    function watch() {
      injectCss();
      $live();                       // live region is in place before content lands
      enhance();

      var t = null;
      function ping() { window.clearTimeout(t); t = window.setTimeout(enhance, 250); }

      function poll() {                    // fallback: no observer available
        var n = 0, iv = window.setInterval(function () {
          if (enhance() || ++n > 60) { window.clearInterval(iv); }
        }, 500);
      }
      var root = document.body || document.documentElement;
      if (window.MutationObserver && root) {
        try {
          new MutationObserver(ping).observe(root, { childList: true, subtree: true });
        } catch (err) { poll(); }
      } else {
        poll();
      }
      $(document).on('variant:change shopify:section:load shopify:block:select', ping);
    }

    $(watch);
  })(window.jQuery);


/*! Sticky footer bottom accessible "https://angelusdirect.com/products/angelus-sneaker-customization-workshop?variant=42032336273474&pb=0" */

  (function () {
    var KEY = 'psaDismissed';

    function init() {
      var bar = document.querySelector('.product-sticky-add');
      if (!bar || bar.dataset.psaReady) return;
      bar.dataset.psaReady = '1';

      /* 1. Landmark + accessible name so SR users can find or skip this repeated block */
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Product quick purchase bar');

      /* 2. Demote the duplicate h5 (h1 already holds the product name; h1->h5 also skipped levels) */
      var title = bar.querySelector('.product-sticky-add-title');
      if (title) title.setAttribute('role', 'presentation');

      /* 3. Thumbnail is decorative here - its alt text duplicated the title */
      var img = bar.querySelector('.product-sticky-add-image');
      if (img) {
        img.setAttribute('alt', '');
        img.setAttribute('role', 'presentation');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }

      var price = bar.querySelector('.product-sticky-add-price');
      if (price && !price.id) price.id = 'psa-price';

      /* 4. Expose unavailable state: button read "Sold Out" but was neither disabled nor aria-disabled */
      function syncState() {
        bar.querySelectorAll('button').forEach(function (b) {
          if (!b.offsetParent && b.offsetWidth === 0) return;
          var t = (b.textContent || '').trim().toLowerCase();
          if (t === 'sold out' || t === 'unavailable') {
            b.setAttribute('aria-disabled', 'true');
            b.setAttribute('aria-describedby', 'psa-price');
          } else {
            b.removeAttribute('aria-disabled');
          }
        });
      }
      syncState();
      new MutationObserver(syncState).observe(bar, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });

      /* 5. Keep the layout offset in sync so the bar never covers content or a focused control */
      function setH() {
        var h = bar.hidden ? 0 : Math.round(bar.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--psa-h', h + 'px');
        document.body.classList.toggle('psa-offset', h > 0);
      }
      setH();
      if (window.ResizeObserver) new ResizeObserver(setH).observe(bar);
      window.addEventListener('resize', setH, { passive: true });

      /* 6. Make the persistent overlay dismissible by pointer and keyboard */
      var row = bar.querySelector('[class*="justify-between"]') || bar.firstElementChild;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'psa-dismiss';
      btn.setAttribute('aria-label', 'Dismiss quick purchase bar');
      btn.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
        '<path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" ' +
        'fill="none" stroke-linecap="round"/></svg>';

      function dismiss() {
        bar.hidden = true;
        bar.style.display = 'none';
        document.body.classList.remove('psa-offset');
        document.documentElement.style.setProperty('--psa-h', '0px');
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        var target = document.querySelector('h1') || document.querySelector('main');
        if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
      }

      btn.addEventListener('click', dismiss);
      bar.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismiss(); });
      if (row) row.appendChild(btn);

      try { if (sessionStorage.getItem(KEY) === '1') dismiss(); } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
})();

/*! Build your own paint set and video accessible on product page  https://angelusdirect.com/products/angelus-pearlescent-18k-gold-paint?variant=26205222533#root
  */

//   (function ($) {
//     'use strict';
//     if (!$) return;

//     /* ============ shared: announcer + focus trap ============ */
//     function announcer() {
//       var $l = $('#a11y-live-announcer');
//       if (!$l.length) {
//         $l = $('<div id="a11y-live-announcer" role="status" aria-live="polite" aria-atomic="true"></div>')
//           .css({ position:'absolute', width:'1px', height:'1px', margin:'-1px', padding:0,
//                 overflow:'hidden', clip:'rect(0 0 0 0)', whiteSpace:'nowrap', border:0 });
//         $('body').append($l);
//       }
//       return $l;
//     }
//     function say(msg) { var $l = announcer(); $l.text(''); setTimeout(function () { $l.text(msg); }, 60); }

//     var SEL = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),' +
//               'select:not([disabled]),textarea:not([disabled]),[role="button"],[tabindex]:not([tabindex="-1"])';

//     function trap($c, ns) {
//       $(document).on('keydown.' + ns, function (e) {
//         if (e.key !== 'Tab') return;
//         var $f = $c.find(SEL).filter(':visible').filter('[tabindex!="-1"]');
//         if (!$f.length) return;
//         var first = $f[0], last = $f[$f.length - 1];
//         if (!$.contains($c[0], document.activeElement)) { e.preventDefault(); first.focus(); return; }
//         if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
//         else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
//       });
//     }
//     function untrap(ns) { $(document).off('keydown.' + ns); }

//     /* =======================================================
//       PART A - CREATOR VIDEO SLIDER  (was 0 keyboard stops)
//       ======================================================= */
//     var $slider = $('[class*="video-slider-wrapper-"]').first();

//     if ($slider.length) {
//       var heading = $('[class*="video-heading-"] h2').first().text().trim() || 'Videos';
//       $slider.attr({ role:'region', 'aria-roledescription':'carousel', 'aria-label': heading });

//       $slider.find('.swiper-slide').each(function (i) {
//         var $slide = $(this);
//         /* the theme binds its click to the INNER div, not the wrapper */
//         var $hit = $slide.find('[class*="video-slide-video-"]').not('[class*="wrapper"]').first();
//         if (!$hit.length) return;
//         var cap = $slide.find('[class*="video-title-"]').text().trim() || ('Video ' + (i + 1));

//         $hit.attr({ role:'button', tabindex:'0', 'aria-haspopup':'dialog',
//                     'aria-label':'Play video: ' + cap });
//         $hit.find('video').attr({ 'aria-hidden':'true', tabindex:'-1' });

//         $hit.on('keydown.a11y', function (e) {
//           if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
//             e.preventDefault();
//             $hit[0].dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
//           }
//         });
//       });

//       $slider.find('[class*="video-btn-prev-"],[class*="video-btn-next-"]').each(function () {
//         var $b = $(this);
//         if (!$b.is('button')) $b.attr('role', 'button');
//         if ($b.attr('tabindex') == null) $b.attr('tabindex', '0');
//         $b.on('keydown.a11y', function (e) {
//           if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $b.trigger('click'); }
//         });
//       });
//     }

//     /* A2. WCAG 2.2.2 / 1.4.2 - a reachable way to stop autoplaying motion */
//     var $auto = $('video[autoplay]').filter(function () {
//       return !$(this).closest('[class*="video-modal-"]').length;
//     });
//     if ($auto.length && $slider.length) {
//       var $toggle = $('<button type="button" class="a11y-motion-toggle" aria-pressed="false">Pause videos</button>');
//       $toggle.on('click', function () {
//         var paused = $toggle.attr('aria-pressed') === 'true';
//         if (paused) {
//           $auto.each(function () { this.play().catch(function () {}); });
//           $toggle.attr('aria-pressed', 'false').text('Pause videos'); say('Videos playing');
//         } else {
//           $auto.each(function () { this.pause(); });
//           $toggle.attr('aria-pressed', 'true').text('Play videos'); say('Videos paused');
//         }
//       });
//       $slider.after($('<div class="a11y-motion-bar"></div>').append($toggle));

//       if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//         $auto.each(function () { this.pause(); this.removeAttribute('autoplay'); });
//         $toggle.attr('aria-pressed', 'true').text('Play videos');
//       }
//     }

//     /* =======================================================
//       PART B - VIDEO MODAL
//       ======================================================= */
//     var $vm = $('[class*="video-modal-template"]').first();

//     if ($vm.length) {
//       $vm.attr({ role:'dialog', 'aria-modal':'true', 'aria-label':'Creator video player' });
//       $vm.find('[class*="video-modal-close-"]').attr({ type:'button', 'aria-label':'Close video' });
//       $vm.find('svg').attr({ 'aria-hidden':'true', focusable:'false' });

//       function mediaBtn($b, labels, read) {
//         if ($b.data('a11y')) return; $b.data('a11y', 1);
//         $b.attr({ role:'button', tabindex:'0' });
//         var sync = function () {
//           var v = $b.closest('[class*="video-modal-slide-"]').find('video')[0];
//           var on = v ? read(v) : true;
//           $b.attr({ 'aria-pressed': on ? 'true' : 'false', 'aria-label': on ? labels[0] : labels[1] });
//         };
//         sync();
//         $b.on('click.a11y', function () { setTimeout(sync, 120); });
//         $b.on('keydown.a11y', function (e) {
//           if (e.key === 'Enter' || e.key === ' ') {
//             e.preventDefault();
//             $b[0].dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
//           }
//         });
//       }
//       $vm.find('[class*="video-modal-play-"]').each(function () {
//         mediaBtn($(this), ['Play video', 'Pause video'], function (v) { return v.paused; });
//       });
//       $vm.find('[class*="video-modal-action-"]').each(function () {
//         mediaBtn($(this), ['Unmute video', 'Mute video'], function (v) { return v.muted; });
//       });

//       /* only the active slide belongs in the tab order */
//       function syncSlides() {
//         var $s = $vm.find('[class*="video-modal-slide-"]');
//         $s.each(function () {
//           var $x = $(this), active = $x.hasClass('swiper-slide-active');
//           var cap = $x.find('[class*="video-modal-title"],[class*="video-title"]').text().trim();
//           $x.attr('aria-hidden', active ? null : 'true');
//           $x.find('[role=button],button,a[href]').attr('tabindex', active ? '0' : '-1');
//           $x.find('video').attr({ tabindex:'-1', 'aria-label':'Creator video' + (cap ? ': ' + cap : '') });
//           if (active) say('Video ' + ($s.index($x) + 1) + ' of ' + $s.length + (cap ? ': ' + cap : ''));
//         });
//       }
//       $vm.find('[class*="video-modal-prev-"],[class*="video-modal-next-"]')
//         .on('click.a11y', function () { setTimeout(syncSlides, 350); });
//       syncSlides();

//       var vOpener = null;
//       $(document).on('click.a11yopen', '[aria-label^="Play video"]', function () { vOpener = this; });

//       function openVM() {
//         var $c = $vm.find('[class*="video-modal-close-"]').filter(':visible').first();
//         if ($c.length) $c.focus();
//         trap($vm, 'videomodal');
//         $('body').css('overflow', 'hidden');
//       }
//       function closeVM() {
//         untrap('videomodal');
//         $vm.find('video').each(function () { this.pause(); });
//         $('body').css('overflow', '');
//         if (vOpener && document.body.contains(vOpener)) $(vOpener).focus();
//       }

//       $(document).on('keydown.a11yvesc', function (e) {
//         if (e.key === 'Escape' && $vm.hasClass('active')) {
//           e.preventDefault();
//           var $c = $vm.find('[class*="video-modal-close-"]').filter(':visible').first();
//           if ($c.length) $c[0].dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
//           closeVM();
//         }
//       });
//       $vm.find('[class*="video-modal-close-"]').on('click.a11y', function () { setTimeout(closeVM, 80); });

//       new MutationObserver(function () {
//         if ($vm.hasClass('active')) { if (!$vm.data('open')) { $vm.data('open', 1); setTimeout(openVM, 120); } }
//         else if ($vm.data('open')) { $vm.data('open', 0); closeVM(); }
//       }).observe($vm[0], { attributes:true, attributeFilter:['class'] });
//     }

//     /* =======================================================
//       PART C - BUILD YOUR OWN PAINT SET
//       ======================================================= */
//     var PICKER = '.mbc-bundles-resource-picker__action';
//     var DIALOG = '.mbc-modal';
//     var mbcOpener = null;

//     $(PICKER).attr({ type:'button', 'aria-haspopup':'dialog', 'aria-expanded':'false' });
//     $(document).on('click.a11ymbc', PICKER, function () {
//       mbcOpener = this;
//       $(this).attr('aria-expanded', 'true');
//     });

//     function mbcCount() {
//       return $('.mbc-bundle__item--product').filter(function () {
//         return $(this).find('.mbc-bundle__item-title').text().trim().length > 0;
//       }).length;
//     }

//     /* name every per-product control so "remove" isn't ambiguous across rows */
//     function labelSet() {
//       $('.mbc-bundle__item--product').each(function () {
//         var $row = $(this);
//         var name = $row.find('.mbc-bundle__item-title').first().text().trim();
//         if (!name) return;

//         $row.find('.mbc-bundles-resource-picker__button-remove')
//             .attr({ type:'button', 'aria-label':'Remove ' + name + ' from your paint set' });

//         $row.find('.mbc-bundle__item-link').attr({ 'aria-hidden':'true', tabindex:'-1' });
//         $row.find('.mbc-bundle__item-thumbnail img').attr('alt', '');

//         var $qty = $row.find('.mbc-bundle__qty-selector');
//         $qty.find('button').each(function () {
//           var t = $(this).text().trim();
//           var dec = (t.indexOf('\u2212') > -1 || t === '-');
//           $(this).attr({ type:'button',
//             'aria-label': (dec ? 'Decrease' : 'Increase') + ' quantity for ' + name });
//         });
//         var $in = $qty.find('input');
//         if ($in.length && !$in.attr('aria-label')) {
//           $in.attr({ 'aria-label':'Quantity for ' + name, inputmode:'numeric' });
//         }

//         var $vc = $row.find('.mbc-bundle__item-variant-container');
//         if ($vc.length && !$vc.attr('role')) {
//           var lbl = $vc.find('.mbc-bundle__swatch-label-option').first().text().replace(':', '').trim() || 'Size';
//           $vc.attr({ role:'radiogroup', 'aria-label': lbl + ' for ' + name });
//         }
//       });
//     }

//     function enhanceDialog() {
//       var $d = $(DIALOG);
//       if (!$d.length || $d.data('a11y')) return;
//       $d.data('a11y', 1);

//       $d.attr({ role:'dialog', 'aria-modal':'true', 'aria-label':'Add a product to your paint set' });
//       $d.find('.mbc-modal__close').attr({ type:'button', 'aria-label':'Close, return to your paint set' });
//       $d.find('.mbc-modal__overlay').attr({ 'aria-hidden':'true', tabindex:'-1' });

//       /* products perform an action - expose as buttons, not links */
//       var $items = $d.find('.mbc-bundles-resource-picker__item-button');
//       $items.each(function () {
//         var $a = $(this), n = $a.text().trim();
//         $a.attr({ role:'button', 'aria-label':'Add ' + n + ' to your paint set' });
//         $a.find('img').attr('alt', '');
//         $a.on('keydown.a11y', function (e) {
//           if (e.key === ' ' || e.key === 'Spacebar') {
//             e.preventDefault();
//             $a[0].dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
//           }
//         });
//       });

//       /* the <li> was tabbable too - that doubled every tab stop */
//       $d.find('li.mbc-bundles-resource-picker__item').removeAttr('tabindex').attr('role', 'listitem');
//       $d.find('ul').attr({ role:'list', 'aria-label': $items.length + ' products available' });

//       say('Add product dialog opened. ' + $items.length + ' products available.');
//       trap($d, 'mbcdialog');
//     }

//     function closeCleanup() {
//       untrap('mbcdialog');
//       $(PICKER).attr('aria-expanded', 'false');
//       if (mbcOpener && document.body.contains(mbcOpener)) $(mbcOpener).focus();
//       else $(PICKER).filter(':visible').last().focus();
//     }

//     $(document).on('keydown.a11ymbcesc', function (e) {
//       if (e.key === 'Escape' && $(DIALOG).length) setTimeout(closeCleanup, 120);
//     });
//     $(document).on('click.a11ymbcclose', '.mbc-modal__close,.mbc-modal__overlay', function () {
//       setTimeout(closeCleanup, 120);
//     });

//     /* announce the product AND the resulting set state, then restore focus */
//     $(document).on('click.a11ymbcpick', '.mbc-bundles-resource-picker__item-button', function () {
//       var n = $(this).text().trim();
//       setTimeout(function () {
//         labelSet();
//         var c = mbcCount();
//         say(n + ' added to your paint set. ' + c + ' product' + (c === 1 ? '' : 's') + ' in set.');
//         closeCleanup();
//       }, 700);
//     });

//     $(document).on('click.a11ymbcrm', '.mbc-bundles-resource-picker__button-remove', function () {
//       var n = $(this).closest('.mbc-bundle__item--product')
//                     .find('.mbc-bundle__item-title').first().text().trim() || 'Product';
//       setTimeout(function () {
//         var c = mbcCount();
//         say(n + ' removed from your paint set. ' + c + ' product' + (c === 1 ? '' : 's') + ' in set.');
//         labelSet();
//         $(PICKER).filter(':visible').last().focus();
//       }, 700);
//     });

//     new MutationObserver(function () {
//       if ($(DIALOG).length) enhanceDialog();
//       labelSet();
//     }).observe(document.body, { childList:true, subtree:true });

//     labelSet();
// })(window.jQuery);



// ============================== Accessible video, adding late on the product product page  https://angelusdirect.com/products/angelus-pearlescent-18k-gold-paint?variant=26205222533#root ================================================================================

  (function ($) {
    'use strict';
    if (!$ || window.__a11yInit) return; window.__a11yInit = true;

    var VM     = '[class*="video-modal-template"]';
    var TILE   = '[data-a11y-tile]';
    var PICKER = '.mbc-bundles-resource-picker__action';
    var DIALOG = '.mbc-modal';

    /* ---------------- announcer (collapses rapid duplicates) ---------------- */
    function say(msg) {
      var $l = $('#a11y-live-announcer');
      if (!$l.length) {
        $l = $('<div id="a11y-live-announcer" role="status" aria-live="polite" aria-atomic="true"></div>')
          .css({ position:'absolute', width:'1px', height:'1px', margin:'-1px', padding:0,
                overflow:'hidden', clip:'rect(0 0 0 0)', whiteSpace:'nowrap', border:0 });
        $('body').append($l);
      }
      msg = String(msg);
      if (say._pending === msg) return;
      if ($l.text().trim() === msg.trim()) return;
      say._pending = msg;
      $l.text('');
      setTimeout(function () {
        if (say._pending !== msg) return;
        $l.text(msg);
        say._pending = null;
      }, 80);
    }
    window.a11ySay = say;

    /* ---------------- focus trap ---------------- */
    var SEL = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),' +
              'select:not([disabled]),textarea:not([disabled]),[role="button"],[tabindex]:not([tabindex="-1"])';
    function trap($c, ns) {
      $(document).off('keydown.' + ns).on('keydown.' + ns, function (e) {
        if (e.key !== 'Tab' || !$c.length) return;
        var $f = $c.find(SEL).filter(':visible').filter('[tabindex!="-1"]');
        if (!$f.length) return;
        var a = $f[0], z = $f[$f.length - 1];
        if (!$.contains($c[0], document.activeElement)) { e.preventDefault(); a.focus(); return; }
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      });
    }
    function untrap(ns) { $(document).off('keydown.' + ns); }

    /* ---------------- FIX 3: hold focus against async re-renders ----------------
      Widgets re-render right after a dialog closes and steal the active element,
      so re-assert for a short window instead of setting focus once.            */
    function holdFocus(el, ms) {
      var until = Date.now() + (ms || 700);
      var tok = (window.__a11yFocusTok = (window.__a11yFocusTok || 0) + 1);
      (function hold() {
        if (tok !== window.__a11yFocusTok) return;      /* a newer restore wins */
        if (Date.now() > until) return;
        if (document.activeElement !== el && document.body.contains(el) && el.offsetParent !== null) {
          el.focus({ preventScroll: true });
        }
        requestAnimationFrame(hold);
      })();
    }

    /* =======================================================================
      IDEMPOTENT ENHANCER - safe to run any number of times, on any new DOM
      ======================================================================= */
    function enhance() {

      /* carousel region */
      $('[class*="video-slider-wrapper-"]').not('[data-a11y-region]').each(function () {
        var $w = $(this).attr('data-a11y-region', '1');
        var h = $('[class*="video-heading-"] h2').first().text().trim() || 'Videos';
        $w.attr({ role:'region', 'aria-roledescription':'carousel', 'aria-label': h });
      });

      /* FIX 2: tile id is the SLIDE INDEX, so a re-render regenerates the same
        ids and focus restore can always find the tile again.                  */
      $('[class*="video-slider-wrapper-"]').each(function () {
        $(this).find('.swiper-slide').each(function (i) {
          var $s = $(this);
          /* the theme binds its click to the INNER div, not the wrapper */
          var $hit = $s.find('[class*="video-slide-video-"]').not('[class*="wrapper"]').first();
          if (!$hit.length || $hit.attr('data-a11y-tile')) return;
          var cap = $s.find('[class*="video-title-"]').text().trim() || ('Video ' + (i + 1));
          $hit.attr({
            'data-a11y-tile': String(i + 1),
            role:'button', tabindex:'0', 'aria-haspopup':'dialog',
            'aria-label':'Play video: ' + cap
          });
          $hit.find('video').attr({ 'aria-hidden':'true', tabindex:'-1' });
        });
      });

      $('[class*="video-btn-prev-"],[class*="video-btn-next-"]').not('[data-a11y-arrow]').each(function () {
        var $b = $(this).attr('data-a11y-arrow', '1');
        if (!$b.is('button')) $b.attr('role', 'button');
        if ($b.attr('tabindex') == null) $b.attr('tabindex', '0');
      });

      /* modal shell + controls */
      $(VM).not('[data-a11y-modal]').attr({
        'data-a11y-modal':'1', role:'dialog', 'aria-modal':'true', 'aria-label':'Creator video player'
      });
      $(VM + ' [class*="video-modal-close-"]').not('[data-a11y-close]')
        .attr({ 'data-a11y-close':'1', type:'button', 'aria-label':'Close video' });
      $(VM + ' svg').attr({ 'aria-hidden':'true', focusable:'false' });
      $(VM + ' [class*="video-modal-play-"]').not('[data-a11y-mc]')
        .attr({ 'data-a11y-mc':'play', role:'button', tabindex:'0' });
      $(VM + ' [class*="video-modal-action-"]').not('[data-a11y-mc]')
        .attr({ 'data-a11y-mc':'mute', role:'button', tabindex:'0' });
      syncMediaLabels();
      syncSlides(false);

      /* autoplay pause control (WCAG 2.2.2 / 1.4.2) */
      var $auto = $('video[autoplay]').filter(function () { return !$(this).closest(VM).length; });
      if ($auto.length && !$('.a11y-motion-toggle').length) {
        var $sl = $('[class*="video-slider-wrapper-"]').first();
        if ($sl.length) {
          var $t = $('<button type="button" class="a11y-motion-toggle" aria-pressed="false">Pause videos</button>');
          $sl.after($('<div class="a11y-motion-bar"></div>').append($t));
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            $auto.each(function () { this.pause(); this.removeAttribute('autoplay'); });
            $t.attr('aria-pressed', 'true').text('Play videos');
          }
        }
      }

      enhanceBundle();
    }

    function syncMediaLabels() {
      $('[data-a11y-mc]').each(function () {
        var $b = $(this), v = $b.closest('[class*="video-modal-slide-"]').find('video')[0];
        if (!v) return;
        if ($b.attr('data-a11y-mc') === 'play') {
          $b.attr({ 'aria-pressed': v.paused ? 'true' : 'false',
                    'aria-label':   v.paused ? 'Play video' : 'Pause video' });
        } else {
          $b.attr({ 'aria-pressed': v.muted ? 'true' : 'false',
                    'aria-label':   v.muted ? 'Unmute video' : 'Mute video' });
        }
      });
    }

    function syncSlides(announce) {
      var $s = $(VM + ' [class*="video-modal-slide-"]');
      if (!$s.length) return;
      $s.each(function () {
        var $x = $(this), on = $x.hasClass('swiper-slide-active');
        var cap = $x.find('[class*="video-modal-title"],[class*="video-title"]').text().trim();
        $x.attr('aria-hidden', on ? null : 'true');
        $x.find('[role=button],button,a[href]').attr('tabindex', on ? '0' : '-1');
        $x.find('video').attr({ tabindex:'-1', 'aria-label':'Creator video' + (cap ? ': ' + cap : '') });
        if (on && announce) say('Video ' + ($s.index($x) + 1) + ' of ' + $s.length + (cap ? ': ' + cap : ''));
      });
    }

    /* =======================================================================
      DELEGATED EVENTS - bound once on document, work for any future node
      ======================================================================= */
    var openerId = null;

    $(document)
      .on('click.a11yv', TILE, function () { openerId = $(this).attr('data-a11y-tile'); })
      .on('keydown.a11yv', TILE, function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openerId = $(this).attr('data-a11y-tile');
          this.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
        }
      })
      .on('keydown.a11yv', '[data-a11y-mc],[data-a11y-arrow]', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
        }
      })
      .on('click.a11yv', '[data-a11y-mc]', function () { setTimeout(syncMediaLabels, 120); })
      .on('click.a11yv', '[class*="video-modal-prev-"],[class*="video-modal-next-"]', function () {
        setTimeout(function () { syncSlides(true); syncMediaLabels(); }, 350);
      })
      .on('click.a11yv', '.a11y-motion-toggle', function () {
        var $t = $(this), on = $t.attr('aria-pressed') === 'true';
        var $a = $('video[autoplay]').filter(function () { return !$(this).closest(VM).length; });
        if (on) { $a.each(function () { this.play().catch(function () {}); });
                  $t.attr('aria-pressed','false').text('Pause videos'); say('Videos playing'); }
        else    { $a.each(function () { this.pause(); });
                  $t.attr('aria-pressed','true').text('Play videos');  say('Videos paused'); }
      })
      .on('click.a11yv', '[data-a11y-close]', function () { setTimeout(closeModal, 90); })
      .on('keydown.a11yvesc', function (e) {
        if (e.key !== 'Escape') return;
        var $m = $(VM + '.active');
        if (!$m.length) return;
        e.preventDefault();
        var $c = $m.find('[data-a11y-close]').filter(':visible').first();
        if ($c.length) $c[0].dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true, view:window }));
        closeModal();
      });

    function openModal() {
      enhance();
      var $m = $(VM + '.active'); if (!$m.length) return;
      trap($m, 'a11yvm');
      $('body').css('overflow', 'hidden');
      var tries = 0;
      (function grab() {
        var $c = $m.find('[data-a11y-close]').filter(':visible').first();
        if ($c.length) { $c[0].focus(); if (document.activeElement === $c[0]) return; }
        if (++tries < 20) requestAnimationFrame(grab);
      })();
    }

    function closeModal() {
      untrap('a11yvm');
      $(VM + ' video').each(function () { this.pause(); });
      $('body').css('overflow', '');
      restoreFocus();
    }

    /* FIX 1: look the tile up by its stable id, never by a stored node ref */
    function restoreFocus() {
      if (!openerId) return;
      var want = openerId, tries = 0;
      (function go() {
        var el = document.querySelector('[data-a11y-tile="' + want + '"]');
        if (el && el.offsetParent !== null) {
          el.focus({ preventScroll: false });
          if (document.activeElement === el) { openerId = null; holdFocus(el, 700); return; }
        }
        if (++tries < 30) { requestAnimationFrame(go); return; }
        var fb = document.querySelector('[data-a11y-tile="' + want + '"]') ||
                document.querySelector('[data-a11y-tile]') ||
                document.querySelector('[data-a11y-region]');
        if (fb) {
          if (!fb.hasAttribute('tabindex')) fb.setAttribute('tabindex', '-1');
          fb.focus(); holdFocus(fb, 700);
        }
        openerId = null;
      })();
    }

    /* =======================================================================
      BUILD YOUR OWN PAINT SET
      ======================================================================= */
    function bundleCount() {
      return $('.mbc-bundle__item--product').filter(function () {
        return $(this).find('.mbc-bundle__item-title').text().trim().length > 0;
      }).length;
    }

    function enhanceBundle() {
      $(PICKER).not('[data-a11y-picker]')
        .attr({ 'data-a11y-picker':'1', type:'button', 'aria-haspopup':'dialog', 'aria-expanded':'false' });

      $('.mbc-bundle__item--product').each(function () {
        var $r = $(this), n = $r.find('.mbc-bundle__item-title').first().text().trim();
        if (!n) return;
        $r.find('.mbc-bundles-resource-picker__button-remove')
          .attr({ type:'button', 'aria-label':'Remove ' + n + ' from your paint set' });
        $r.find('.mbc-bundle__item-link').attr({ 'aria-hidden':'true', tabindex:'-1' });
        $r.find('.mbc-bundle__item-thumbnail img').attr('alt', '');
        $r.find('.mbc-bundle__qty-selector button').each(function () {
          var t = $(this).text().trim(), dec = (t.indexOf('\u2212') > -1 || t === '-');
          $(this).attr({ type:'button', 'aria-label': (dec ? 'Decrease' : 'Increase') + ' quantity for ' + n });
        });
        var $in = $r.find('.mbc-bundle__qty-selector input');
        if ($in.length && !$in.attr('aria-label')) {
          $in.attr({ 'aria-label':'Quantity for ' + n, inputmode:'numeric' });
        }
        var $vc = $r.find('.mbc-bundle__item-variant-container');
        if ($vc.length && !$vc.attr('role')) {
          var l = $vc.find('.mbc-bundle__swatch-label-option').first().text().replace(':', '').trim() || 'Size';
          $vc.attr({ role:'radiogroup', 'aria-label': l + ' for ' + n });
        }
      });

      var $d = $(DIALOG);
      if ($d.length && !$d.attr('data-a11y-dlg')) {
        $d.attr({ 'data-a11y-dlg':'1', role:'dialog', 'aria-modal':'true',
                  'aria-label':'Add a product to your paint set' });
        $d.find('.mbc-modal__close').attr({ type:'button', 'aria-label':'Close, return to your paint set' });
        $d.find('.mbc-modal__overlay').attr({ 'aria-hidden':'true', tabindex:'-1' });
        var $i = $d.find('.mbc-bundles-resource-picker__item-button');
        $i.each(function () {
          var $a = $(this);
          $a.attr({ role:'button', 'aria-label':'Add ' + $a.text().trim() + ' to your paint set' });
          $a.find('img').attr('alt', '');
        });
        /* the <li> was tabbable too, which doubled every tab stop */
        $d.find('li.mbc-bundles-resource-picker__item').removeAttr('tabindex').attr('role', 'listitem');
        $d.find('ul').attr({ role:'list', 'aria-label': $i.length + ' products available' });
        say('Add product dialog opened. ' + $i.length + ' products available.');
        trap($d, 'a11ymbc');
      }
    }

    function bundleCleanup() {
      untrap('a11ymbc');
      $(PICKER).attr('aria-expanded', 'false');
      var tok = (window.__a11yFocusTok = (window.__a11yFocusTok || 0) + 1);
      var tries = 0;
      (function go() {
        if (tok !== window.__a11yFocusTok) return;
        var el = $(PICKER).filter(':visible').last()[0];
        if (el) { el.focus(); if (document.activeElement === el) { holdFocus(el, 700); return; } }
        if (++tries < 30) requestAnimationFrame(go);
      })();
    }

    /* NOTE: no Space handler on picker items - the bundle app already handles
      Space, and adding our own caused the product to be added twice.        */
    $(document)
      .on('click.a11ymbc', PICKER, function () {
        $(PICKER).attr('aria-expanded', 'false');
        $(this).attr('aria-expanded', 'true');
      })
      .on('click.a11ymbc', '.mbc-bundles-resource-picker__item-button', function () {
        var n = $(this).text().trim();
        setTimeout(function () {
          enhanceBundle();
          var c = bundleCount();
          say(n + ' added to your paint set. ' + c + ' product' + (c === 1 ? '' : 's') + ' in set.');
          bundleCleanup();
        }, 700);
      })
      .on('click.a11ymbc', '.mbc-bundles-resource-picker__button-remove', function () {
        var n = $(this).closest('.mbc-bundle__item--product')
                      .find('.mbc-bundle__item-title').first().text().trim() || 'Product';
        setTimeout(function () {
          var c = bundleCount();
          say(n + ' removed from your paint set. ' + c + ' product' + (c === 1 ? '' : 's') + ' in set.');
          enhanceBundle();
          bundleCleanup();
        }, 700);
      })
      .on('click.a11ymbc', '.mbc-modal__close,.mbc-modal__overlay', function () { setTimeout(bundleCleanup, 120); })
      .on('keydown.a11ymbcesc', function (e) {
        if (e.key === 'Escape' && $(DIALOG).length) setTimeout(bundleCleanup, 150);
      });

    /* =======================================================================
      ONE OBSERVER - covers late DOM, re-renders and modal state changes
      ======================================================================= */
    var wasOpen = false, queued = false;
    function tick() {
      queued = false;
      enhance();
      var open = $(VM + '.active').length > 0;
      if (open && !wasOpen)      { wasOpen = true;  openModal(); }
      else if (!open && wasOpen) { wasOpen = false; closeModal(); }
    }
    new MutationObserver(function () {
      if (queued) return; queued = true; requestAnimationFrame(tick);
    }).observe(document.documentElement, {
      childList:true, subtree:true, attributes:true, attributeFilter:['class']
    });

    tick();
    $(function () { tick(); });
    $(window).on('load', function () { tick(); setTimeout(tick, 1000); setTimeout(tick, 3000); });
    [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(tick, ms); });

    window.a11yEnhance = tick;   /* call manually after any AJAX section swap */
})(window.jQuery);

// ==============================  product filter not annouce sort opton was not screen reader compliant ================================================================================

//   (function () {
//   'use strict';

//   var DESKTOP_FORM = '#js-desktopFilter';
//   var TRIGGER = 'button[aria-controls^="filter-panel"]';
//   var COUNT_SELECTOR = 'p.type--small.mb-4';   // visible "N products found"
//   var RESTORE_KEY = 'a11y:filterFocus';

//   /* ---------------------------------------------------------------
//    * 1. A single, PERSISTENT live region that survives re-renders.
//    *    It is created once, outside the section that Shopify replaces,
//    *    and is visually hidden the correct way (never display:none).
//    * ------------------------------------------------------------- */
//   var announcer = document.getElementById('a11y-filter-announcer');
//   if (!announcer) {
//     announcer = document.createElement('div');
//     announcer.id = 'a11y-filter-announcer';
//     announcer.setAttribute('role', 'status');
//     announcer.setAttribute('aria-live', 'polite');
//     announcer.setAttribute('aria-atomic', 'true');
//     announcer.style.cssText =
//       'position:absolute!important;width:1px;height:1px;margin:-1px;' +
//       'padding:0;overflow:hidden;clip:rect(0 0 0 0);' +
//       'clip-path:inset(50%);white-space:nowrap;border:0;';
//     document.body.appendChild(announcer);
//   }

//   var announceTimer = null;
//   function announce(message) {
//     if (!message) return;
//     clearTimeout(announceTimer);
//     announcer.textContent = '';               // force a diff
//     announceTimer = setTimeout(function () {
//       announcer.textContent = message;
//     }, 150);                                  // let the DOM settle first
//   }

//   /* Neutralise the theme's broken display:none status node so the
//      same information isn't duplicated or silently swallowed. */
//   function hideBrokenStatus(root) {
//     (root || document)
//       .querySelectorAll('[role="status"][style*="display:none"]')
//       .forEach(function (el) {
//         el.removeAttribute('role');
//         el.removeAttribute('aria-live');
//       });
//   }

//   /* ---------------------------------------------------------------
//    * 2. Correct radiogroup semantics + current value on the trigger.
//    * ------------------------------------------------------------- */
//   function enhance(root) {
//     root = root || document;

//     root.querySelectorAll(TRIGGER).forEach(function (btn) {
//       var panel = document.getElementById(btn.getAttribute('aria-controls'));
//       if (!panel || panel.dataset.a11yDone === 'true') return;

//       var radios = panel.querySelectorAll('input[type="radio"]');
//       var label  = (btn.textContent || '').trim().split(/\s+/)[0];

//       if (radios.length) {
//         /* role="group" -> role="radiogroup" so AT announces
//            "Sort radio group, 3 of 9" instead of a bare grouping. */
//         panel.setAttribute('role', 'radiogroup');
//         if (!panel.getAttribute('aria-label')) {
//           panel.setAttribute('aria-label', 'Sort by');
//         }

//         radios.forEach(function (radio, i) {
//           if (!radio.id) radio.id = 'sortby-opt-' + i;
//           var wrap = radio.closest('label');
//           if (wrap && !wrap.getAttribute('for')) {
//             wrap.setAttribute('for', radio.id);   // belt-and-braces
//           }
//           /* Expose the selection change immediately, before the
//              page re-renders and the node is thrown away. */
//           radio.addEventListener('change', function () {
//             var text = (wrap ? wrap.textContent : radio.value).trim();
//             rememberFocus(btn);
//             announce('Sort by ' + text + '. Updating results\u2026');
//           });
//         });

//         /* Put the current value in the button's accessible name,
//            matching the "Product type (1)" pattern. */
//         var current = panel.querySelector('input[type="radio"]:checked');
//         if (current) {
//           var cur = (current.closest('label') || current).textContent
//                       .trim().replace(/\s+/g, ' ');
//           btn.setAttribute('aria-label', 'Sort by, current selection: ' + cur);
//         }
//       }

//       /* Checkbox facets: remember focus so it can be restored. */
//       panel.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
//         cb.addEventListener('change', function () {
//           rememberFocus(btn);
//           var name = (cb.closest('label') || cb).textContent
//                        .trim().replace(/\s+/g, ' ');
//           announce((cb.checked ? 'Added filter ' : 'Removed filter ') +
//                    label + ' ' + name + '. Updating results\u2026');
//         });
//       });

//       panel.dataset.a11yDone = 'true';
//     });

//     hideBrokenStatus(root);
//   }

//   /* ---------------------------------------------------------------
//    * 3. Preserve focus across the re-render.
//    * ------------------------------------------------------------- */
//   function rememberFocus(btn) {
//     var key = (btn.textContent || '').trim().split(/\s+/)[0].toLowerCase();
//     try { sessionStorage.setItem(RESTORE_KEY, key); } catch (e) {}
//   }

//   function restoreFocus() {
//     var key;
//     try { key = sessionStorage.getItem(RESTORE_KEY); } catch (e) {}
//     if (!key) return;
//     try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}

//     var target = Array.prototype.find.call(
//       document.querySelectorAll(DESKTOP_FORM + ' ' + TRIGGER),
//       function (b) {
//         return (b.textContent || '').trim().toLowerCase().indexOf(key) === 0;
//       }
//     );
//     if (target) {
//       target.focus({ preventScroll: false });
//     }
//   }

//   /* ---------------------------------------------------------------
//    * 4. Announce the new result count once the grid has re-rendered,
//    *    and re-apply enhancements to the replaced nodes.
//    * ------------------------------------------------------------- */
//   var lastCount = null;
//   function readCount() {
//     var el = document.querySelector(COUNT_SELECTOR);
//     return el ? el.textContent.trim().replace(/\s+/g, ' ') : null;
//   }
//   lastCount = readCount();

//   var settle = null;
//   var observer = new MutationObserver(function () {
//     clearTimeout(settle);
//     settle = setTimeout(function () {
//       enhance(document);

//       var count = readCount();
//       if (count && count !== lastCount) {
//         lastCount = count;
//         var applied = Array.prototype.map.call(
//           document.querySelectorAll('a[href*="filter."]'),
//           function (a) { return a.textContent.trim().replace(/\s+/g, ' '); }
//         ).filter(Boolean);

//         announce(
//           count +
//           (applied.length ? '. Active filters: ' + applied.join(', ') : '') +
//           '.'
//         );
//       }
//       restoreFocus();
//     }, 250);
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

//   /* ---------------------------------------------------------------
//    * 5. Keep the panel open while multi-selecting checkboxes.
//    *    Stop the theme's outside/change close handler from firing
//    *    for checkbox facets only (Sort still closes, as expected).
//    * ------------------------------------------------------------- */
//   document.addEventListener('change', function (e) {
//     var cb = e.target;
//     if (!(cb instanceof HTMLInputElement) || cb.type !== 'checkbox') return;
//     var panel = cb.closest('[id^="filter-panel"]');
//     if (!panel) return;
//     var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
//     if (btn) { btn.dataset.keepOpen = 'true'; }
//   }, true);

//   document.addEventListener('DOMContentLoaded', function () {
//     enhance(document);
//     restoreFocus();
//   });
//   enhance(document);
//   restoreFocus();
// })();


/* Angelus Direct — collection filter accessibility remediation
   Load with `defer` after the collection filter section. */
(function () {
  'use strict';

  var FORM          = '#js-desktopFilter';
  var FOCUS_WINDOW  = 5000;   // ms to keep re-asserting focus across re-renders
  var SETTLE_MS     = 220;    // debounce after the AJAX re-render
  var ANNOUNCE_COUNT = true;  // set false if ADA Pro already reads the result count

  var uid = 0, observers = [];

  /* ---------- 1. Live region inside a shadow root ----------
     ada-pro.js hunts for [role="status"] in the light DOM and hijacks it.
     A shadow root is unreachable by document.querySelector but is still
     announced by NVDA / JAWS / VoiceOver.                                  */
  var host = document.getElementById('a11y-filter-host');
  if (!host) {
    host = document.createElement('div');
    host.id = 'a11y-filter-host';
    host.style.cssText =
      'position:absolute!important;width:1px!important;height:1px!important;' +
      'overflow:hidden!important;clip:rect(0 0 0 0)!important;' +
      'clip-path:inset(50%)!important;white-space:nowrap!important;';
    document.body.appendChild(host);
    host.attachShadow({ mode: 'open' });
  }
  var sr = host.shadowRoot;
  var announcer = sr.querySelector('#live');
  if (!announcer) {
    announcer = document.createElement('div');
    announcer.id = 'live';
    announcer.setAttribute('role', 'status');
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    sr.appendChild(announcer);
  }
  function say(msg) {
    msg = (msg || '').trim();
    if (!msg || msg === '.') return;
    announcer.textContent = '';
    setTimeout(function () { announcer.textContent = msg; }, 120);
  }

  function clean(s) {
    return (s || '').replace(/\s+/g, ' ').replace(/\s*\(\d+\)\s*$/, '').trim();
  }
  function slug(s) {
    return clean(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function shown(el) {
    return !!el && getComputedStyle(el).display !== 'none' && el.offsetParent !== null;
  }

  /* ---------- 2. One combined message, never clobbered ---------- */
  var pendingAction = null, pendingTimer = null, lastCount = null;

  function queueAction(text) {
    pendingAction = text;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      if (pendingAction) { say(pendingAction); pendingAction = null; }
    }, 1500);                       // fires when the count doesn't change
  }
  function flush(count, filters) {
    clearTimeout(pendingTimer);
    var parts = [];
    if (pendingAction) parts.push(pendingAction);
    pendingAction = null;
    if (ANNOUNCE_COUNT) {
      parts.push(count);
      parts.push(filters.length ? 'Active filters: ' + filters.join(', ')
                                : 'No filters applied');
    }
    if (parts.length) say(parts.join('. ') + '.');
  }
  function readCount() {
    var el = document.querySelector('p.type--small.mb-4, #filtered-product-count');
    return el ? clean(el.textContent) : null;
  }
  function readFilters() {
    var seen = {}, out = [];
    document.querySelectorAll('a[href*="filter."]').forEach(function (a) {
      if (a.closest('#js-mobileFilter') || a.offsetParent === null) return;
      var t = clean(a.textContent);
      if (!t || /^clear all$/i.test(t) || seen[t]) return;
      seen[t] = 1; out.push(t);
    });
    return out;
  }

  /* ---------- 3. Focus watchdog that survives repeated re-renders ---------- */
  var pendingFocus = null;
  function rememberFocus(key) {
    pendingFocus = { key: key, until: Date.now() + FOCUS_WINDOW };
    tick();
  }
  function tick() {
    if (!pendingFocus) return;
    if (Date.now() > pendingFocus.until) { pendingFocus = null; return; }
    var ae = document.activeElement;
    // only reclaim focus if the re-render dropped it; never steal from the user
    if (!ae || ae === document.body || ae === document.documentElement) {
      var t = document.querySelector(FORM + ' [data-a11y-facet="' + pendingFocus.key + '"]');
      if (t) t.focus({ preventScroll: true });
    }
    setTimeout(tick, 80);
  }

  /* ---------- 4. Structural detection — works with BOTH theme variants ---------- */
  function dropdowns() {
    var out = [];
    document.querySelectorAll(FORM + ' button').forEach(function (btn) {
      var root = btn.closest('[x-data]');
      if (!root) return;
      var panel = null;
      [].forEach.call(root.children, function (c) {
        if (c.contains(btn)) return;
        if (c.querySelector && c.querySelector('input[type=radio],input[type=checkbox]')) panel = c;
      });
      if (!panel && btn.getAttribute('aria-controls')) {
        panel = document.getElementById(btn.getAttribute('aria-controls'));
      }
      if (panel) out.push({ btn: btn, panel: panel });
    });
    return out;
  }

  function enhance() {
    dropdowns().forEach(function (d) {
      var btn = d.btn, panel = d.panel;
      var name = clean(btn.textContent) || 'Filter';
      var key  = slug(name);

      btn.setAttribute('data-a11y-facet', key);
      if (!panel.id) panel.id = 'a11y-filter-panel-' + (++uid);
      btn.setAttribute('aria-haspopup', 'true');
      btn.setAttribute('aria-controls', panel.id);
      btn.setAttribute('aria-expanded', shown(panel) ? 'true' : 'false');

      var radios = panel.querySelectorAll('input[type=radio]');
      panel.setAttribute('role', radios.length ? 'radiogroup' : 'group');
      if (!panel.getAttribute('aria-label')) panel.setAttribute('aria-label', name);

      var cur = panel.querySelector('input[type=radio]:checked');
      if (cur) {
        btn.setAttribute('aria-label',
          name + ', current selection ' + clean((cur.closest('label') || cur).textContent));
      }

      if (panel.dataset.a11yDone === '1') return;   // listeners once per node
      panel.dataset.a11yDone = '1';

      // keep aria-expanded in sync with Alpine's x-show inline style
      var mo = new MutationObserver(function () {
        btn.setAttribute('aria-expanded', shown(panel) ? 'true' : 'false');
      });
      mo.observe(panel, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      observers.push(mo);

      // Escape to dismiss — missing entirely in the Alpine variant
      function onKey(e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (!shown(panel)) return;
        e.stopPropagation();
        btn.click();
        btn.focus({ preventScroll: true });
      }
      panel.addEventListener('keydown', onKey);
      btn.addEventListener('keydown', onKey);

      radios.forEach(function (r, i) {
        if (!r.id) r.id = 'a11y-' + key + '-r' + i;
        var w = r.closest('label');
        if (w && !w.hasAttribute('for')) w.setAttribute('for', r.id);
        r.addEventListener('change', function () {
          rememberFocus(key);
          queueAction('Sorted by ' + clean(w ? w.textContent : r.value));
        });
      });

      panel.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          rememberFocus(key);
          var v = clean((cb.closest('label') || cb).textContent);
          queueAction((cb.checked ? 'Added ' : 'Removed ') + name + ' ' + v);
        });
      });
    });

    /* ---------- 5. "Remove …" naming + removal announcements ---------- */
    document.querySelectorAll('a[href*="filter."]').forEach(function (a) {
      var t = clean(a.textContent);
      if (!t || /^clear all$/i.test(t)) return;
      // accessible name: "Remove Product type: Metallic Paint"
      a.setAttribute('aria-label', 'Remove ' + t);
      if (a.dataset.a11yPill === '1') return;
      a.dataset.a11yPill = '1';
      a.addEventListener('click', function () {
        rememberFocus(slug(t.split(':')[0]));
        queueAction('Removed ' + t);
      });
    });

    document.querySelectorAll('a').forEach(function (a) {
      if (!/^clear all$/i.test(clean(a.textContent))) return;
      a.setAttribute('aria-label', 'Clear all filters');
      if (a.dataset.a11yClear === '1') return;
      a.dataset.a11yClear = '1';
      a.addEventListener('click', function () {
        rememberFocus('sort');
        queueAction('Cleared all filters');
      });
    });

    /* theme ships a role="status" node with inline display:none — it can
       never announce, so strip the role rather than leave a dead region */
    document.querySelectorAll('[role="status"]').forEach(function (el) {
      if (sr.contains(el)) return;
      if (getComputedStyle(el).display === 'none') {
        el.removeAttribute('role');
        el.removeAttribute('aria-live');
      }
    });
  }

  lastCount = readCount();
  var settle = null;
  var obs = new MutationObserver(function () {
    clearTimeout(settle);
    settle = setTimeout(function () {
      enhance();
      var c = readCount();
      if (c && c !== lastCount) { lastCount = c; flush(c, readFilters()); }
    }, SETTLE_MS);
  });
  obs.observe(document.body, { childList: true, subtree: true });
  observers.push(obs);

  enhance();
})();

setTimeout(function(){ 
      (function () {
              'use strict';
              var FOCUSABLE = 'a[href],area[href],button,input:not([type="hidden"]),select,textarea,' +
                              'iframe,object,embed,summary,audio[controls],video[controls],' +
                              '[contenteditable="true"],[tabindex]';
              var SUPPORTS_INERT = 'inert' in HTMLElement.prototype;
              document.documentElement.classList.add('js-a11y');

              function reduceMotion(){ return matchMedia('(prefers-reduced-motion: reduce)').matches; }

              /* hide/expose a subtree for both AT and keyboard (inert + tabindex fallback) */
              function hideFromAT(el, on) {
                if (on) {
                  el.setAttribute('aria-hidden', 'true');
                  if (SUPPORTS_INERT) el.setAttribute('inert', '');
                  else [].forEach.call(el.querySelectorAll(FOCUSABLE), function (n) {
                    if (!n.hasAttribute('data-a11y-ti'))
                      n.setAttribute('data-a11y-ti', n.hasAttribute('tabindex') ? n.getAttribute('tabindex') : 'none');
                    n.setAttribute('tabindex', '-1');
                  });
                } else {
                  el.removeAttribute('aria-hidden');
                  el.removeAttribute('inert');
                  [].forEach.call(el.querySelectorAll('[data-a11y-ti]'), function (n) {
                    var v = n.getAttribute('data-a11y-ti');
                    if (v === 'none') n.removeAttribute('tabindex'); else n.setAttribute('tabindex', v);
                    n.removeAttribute('data-a11y-ti');
                  });
                }
              }

              function tabbables(root) {
                return [].filter.call(root.querySelectorAll(FOCUSABLE), function (n) {
                  if (n.disabled || n.tabIndex < 0) return false;
                  var r = n.getBoundingClientRect();
                  if (r.width < 1 && r.height < 1) return false;
                  for (var p = n; p && p.nodeType === 1; p = p.parentElement) {
                    var cs = getComputedStyle(p);
                    if (cs.display === 'none' || cs.visibility !== 'visible') return false;
                  }
                  return true;
                });
              }

              /* remember what opened an overlay so focus can be returned */
              var lastTrigger = null;
              document.addEventListener('pointerdown', function (e) {
                var t = e.target.closest && e.target.closest('a,button,[role="button"],[tabindex]');
                if (t && !t.closest('[class*="video-modal-template--"]')) lastTrigger = t;
              }, true);

              /* ================= 1. BACK TO TOP ================= */
              var btt = document.getElementById('back-to-top');
              if (btt) {
                btt.setAttribute('type', 'button');
                if (!btt.getAttribute('aria-label')) btt.setAttribute('aria-label', 'Back to top');
                [].forEach.call(btt.querySelectorAll('svg'), function (s) {
                  s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
                });

                var syncBtt = function () {
                  btt.classList.toggle('is-visible',
                    (window.pageYOffset || document.documentElement.scrollTop) > 300);
                };
                syncBtt();
                addEventListener('scroll', syncBtt, { passive: true });
                addEventListener('resize', syncBtt);

                btt.addEventListener('click', function () {
                  scrollTo({ top: 0, left: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
                  var target = document.querySelector('#MainContent, main, [role="main"], header, body');
                  if (target) {                       // move focus, don't just move the viewport
                    target.setAttribute('tabindex', '-1');
                    try { target.focus({ preventScroll: true }); } catch (e) {}
                    target.addEventListener('blur', function () { target.removeAttribute('tabindex'); }, { once: true });
                  }
                });
              }

              /* ================= 2a. VIDEO PLAYER MODAL ================= */
              [].filter.call(document.querySelectorAll('[class*="video-modal-template--"]'), function (el) {
                return /(^|\s)video-modal-template--/.test(el.className || '');
              }).forEach(function (modal) {
                modal.setAttribute('role', 'dialog');
                modal.setAttribute('aria-modal', 'true');
                if (!modal.getAttribute('aria-label')) modal.setAttribute('aria-label', 'Video player');
                modal.setAttribute('tabindex', '-1');
                [].forEach.call(modal.querySelectorAll('[role="button"]'), function (b) {
                  if (!b.hasAttribute('tabindex')) b.setAttribute('tabindex', '0');
                });

                var opener = null;
                var isOpen   = function () { return modal.classList.contains('active'); };
                var closeBtn = function () { return modal.querySelector('[class*="video-modal-close"]'); };

                function open() {
                  opener = lastTrigger;
                  hideFromAT(modal, false);
                  var f = closeBtn() || modal;
                  requestAnimationFrame(function () { try { f.focus({ preventScroll: true }); } catch (e) {} });
                }
                function close() {
                  [].forEach.call(modal.querySelectorAll('video'), function (v) { try { v.pause(); } catch (e) {} });
                  if (modal.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
                  hideFromAT(modal, true);
                  if (opener && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
                }

                modal.addEventListener('keydown', function (e) {
                  if (!isOpen()) return;

                  if (e.key === 'Escape' || e.key === 'Esc') {          // Esc closes
                    e.preventDefault(); e.stopPropagation();
                    var c = closeBtn();
                    if (c) c.click(); else modal.classList.remove('active');
                    return;
                  }
                  // if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                  //   var b = e.target.closest && e.target.closest('[role="button"]');   // div[role=button] support
                  //   if (b && b.tagName !== 'BUTTON' && b.tagName !== 'A') { e.preventDefault(); b.click(); return; }
                  // }
                  if (e.key === 'Tab') {                                 // focus trap
                    var list = tabbables(modal);
                    if (!list.length) return;
                    var first = list[0], last = list[list.length - 1];
                    if (e.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
                      e.preventDefault(); last.focus();
                    } else if (!e.shiftKey && document.activeElement === last) {
                      e.preventDefault(); first.focus();
                    }
                  }
                });

                var wasOpen = isOpen();
                if (!wasOpen) hideFromAT(modal, true);
                new MutationObserver(function () {
                  var now = isOpen();
                  if (now === wasOpen) return;
                  wasOpen = now;
                  now ? open() : close();
                }).observe(modal, { attributes: true, attributeFilter: ['class'] });
              });

              /* ================= 2b. MESSAGE / CHAT DIALOG FRAMES ================= */
              var FRAME_SEL = '#chat-campaigns,#chat-input,#mount-floating-engagement-widget,' +
                              'iframe[id^="chat-"],iframe[class*="gorgias"]';

              function syncFrame(f) {
                if (f.id === 'chat-button') return;                 // launcher must stay reachable
                var cs = getComputedStyle(f), r = f.getBoundingClientRect();
                var offscreen = cs.display === 'none' || cs.visibility !== 'visible' ||
                                parseFloat(cs.opacity) === 0 || r.height < 4 || r.width < 4;
                if (offscreen) {
                  f.setAttribute('tabindex', '-1');
                  f.setAttribute('aria-hidden', 'true');
                  f.setAttribute('data-a11y-offscreen', 'true');
                } else {
                  f.removeAttribute('tabindex');
                  f.removeAttribute('aria-hidden');
                  f.removeAttribute('data-a11y-offscreen');
                  if (!f.getAttribute('title')) f.setAttribute('title', 'Message dialog');
                }
              }

              var ro = window.ResizeObserver
                ? new ResizeObserver(function (es) { es.forEach(function (en) { syncFrame(en.target); }); })
                : null;

              function registerFrames() {
                [].forEach.call(document.querySelectorAll(FRAME_SEL), function (f) {
                  syncFrame(f);
                  if (f.getAttribute('data-a11y-frame') === '1') return;
                  f.setAttribute('data-a11y-frame', '1');
                  if (ro) ro.observe(f);
                  new MutationObserver(function () { syncFrame(f); })
                    .observe(f, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
                });
              }
              registerFrames();
              new MutationObserver(registerFrames).observe(document.body, { childList: true, subtree: true });

              /* ================= 3. #chat-button (launcher) ================= */
              function enhanceChatButton() {
                var f = document.getElementById('chat-button');
                if (!f) return false;
                f.removeAttribute('aria-hidden');
                var d; try { d = f.contentDocument; } catch (e) { return false; }   // same-origin srcdoc
                if (!d || !d.body) return false;

                var btn = d.querySelector('button, [role="button"]');
                if (!btn) return false;
                btn.setAttribute('type', 'button');
                if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Chat with us');
                f.setAttribute('title', btn.getAttribute('aria-label'));   // iframe name matches the control

                [].forEach.call(d.querySelectorAll('svg'), function (s) {
                  s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false'); s.removeAttribute('role');
                });

                if (!d.getElementById('a11y-chat-style')) {
                  var st = d.createElement('style');
                  st.id = 'a11y-chat-style';
                  st.textContent =
                    'html,body{margin:0}' +
                    'button{min-width:44px;min-height:44px;}' +
                    'button:focus{outline:3px solid #111 !important;outline-offset:2px !important;}' +
                    'button:focus-visible{outline:3px solid #111 !important;outline-offset:2px !important;}' +
                    '@media (prefers-reduced-motion:reduce){*{animation:none!important;transition:none!important;}}';
                  (d.head || d.body).appendChild(st);
                }

                if (!d.body.hasAttribute('data-a11y-chat')) {
                  d.body.setAttribute('data-a11y-chat', '1');
                  d.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                      var t = e.target.closest && e.target.closest('[role="button"]');
                      if (t && t.tagName !== 'BUTTON') { e.preventDefault(); t.click(); }
                    }
                  });
                }
                return true;
              }
              if (!enhanceChatButton()) {                 // widget loads async
                var n = 0, iv = setInterval(function () { if (enhanceChatButton() || ++n > 40) clearInterval(iv); }, 500);
              }

              /* Esc closes an open chat panel and returns focus to the launcher */
              document.addEventListener('keydown', function (e) {
                if (e.key !== 'Escape' && e.key !== 'Esc') return;
                var panel = document.querySelector('#chat-window,#chat-campaigns');
                if (!panel || panel.getBoundingClientRect().height <= 40) return;
                var f = document.getElementById('chat-button');
                try {
                  var b = f && f.contentDocument && f.contentDocument.querySelector('button');
                  if (b) { b.click(); b.focus(); }
                } catch (err) {}
              });
            })();
     },
  5000); 
















